import { apiInstance } from 'src/services';
import styles from './styles.module.scss';
import { Accordion, ActionIcon, Badge, Box, Menu, Card, Divider, TextInput, FileInput, Flex, Checkbox, Group, MultiSelect, Space, Text, Title, Tooltip, UnstyledButton, NumberInput, Textarea, Loader, Select, Tabs, Navbar, ScrollArea, Radio, Code, Paper, CopyButton} from '@mantine/core';
import Permissions from '../Permissions';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useAlert, useFormFocus } from '@common/hooks';
import { _UpdateremoveAccessToOrganizationSagaSucess, addCategory, assignComanyPermission, assignComanyRole, assignWebSitePermission, currentAction, deleteCategory, deleteClientFromOrganisation, deleteOrganizationfun, fetchCompanies, fetchCompanySiteList, fetchReportSettings, fetchSiteList, fetchSitesDetails, getClientOrganizations, getCompanyWebsies, getJoinedOrganization, getOrganizationSites, getOwnCompanies, getOwnCompanyUsers, grantAccessToOrganization, IReportSettings, ISiteListData, removeAccessToOrganization, removeSiteList, removeUserFromCompany, resetState, RootState, selectedSite, updateCategory, updateCompanyName, updateCurrent, updategrantAccessToOrganizationSuccess, UpdateremoveAccessToOrganizationSaga, updateremoveSite, updateReportSettings, useAppDispatch, useAppSelector } from 'src/store';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { shallowEqual } from 'react-redux';
import { useForm, yupResolver } from '@mantine/form';
import * as yup from 'yup';
import { validationPattern } from '@common/helpers';
import { AutomatedAuditLoader, Button, Modal, PasswordInput, Popover } from '@common/components';
import classNames from 'classnames';
import SitemapTable from '../SitemapPage/sitemapTable';
import { Button as ButtonMantin } from '@mantine/core';
import { Checkbox as CheckboxMantin } from '@common/components';
import { AlignJustify, Check, ChevronUp, Copy, Edit, Link2, Lock, LogIn, MoreVertical, Plus, Save, Settings, Tag, Trash2, Users } from '@geist-ui/icons';
import { AddSiteForm } from 'src/components';
import { formatDateFromTimestamp } from 'src/helpers/parseDateTimeToUTC';
import { checkValidHttps } from '@common/helpers/checkValidHttps';
import { displayName, wrapText } from 'src/helpers/textWrap';
import {  store } from 'src/store/store';

// Define a type for the user object
type User = {
    id: string;
    name: string;
    role: string;
    status: string;
    email: string;
    img: string;
};



// Define a type for the website object
type Website = {
    name: string;
    url: string;
    icon: string; // Assuming this is the URL or path to the icon
    tags: any,
    status: string,
    message?: string
};


// Define the Invitation type
type Invitation = {
    companyName: string;
    invitedUser: string;
    status: 'Pending' | 'Accepted' | 'Declined';
    date: string; // Use a string for simplicity (you can use a date object as well)
};


function MainAccordion({ isAccountPage, organizationId, siteUUID, panel, amIAdmin }: { isAccountPage: boolean, organizationId?: string, siteUUID?: string, panel?: string , amIAdmin:boolean}) {
    const { showAlert } = useAlert()

    const [ invitaionSectionOpened , setInvitaionSectionOpened ] = useState("")
    const navigateToPayment = (): void => {
        apiInstance.get('payment/portal').then((res) => {
            window.location = res.data.url;
        });
    };
    const {
        createOrganization, 
        addCategorydata ,
        updateCategorydata,
        loadingupdateCategory,
        deleteCategorydata ,
        removeUserFromComp ,
        updateNameCompany
      } = useAppSelector((state) => state.organization, shallowEqual);
      const selectedSiteData = useAppSelector((state) => state.site.selectedSiteData, shallowEqual);
      const { siteAdded  } = useAppSelector((state) => state.siteList, shallowEqual);
      const [searchParams, setSearchParams] = useSearchParams();
      const companyId = searchParams.get('company');

    const { websiteCount} = useAppSelector((state) => state.user.data, shallowEqual);
    const {getOwnCompaniesdata, ClientOrganizations ,CompanyUsers} = useAppSelector((state) => state.organization, shallowEqual);
    const accordionElement = document.getElementById('MainAccordion-panel-manage_roles');
    useEffect(() => {
        const timer = setTimeout(() => {
            if (accordionElement) {
                accordionElement.focus();
              }
        }, 3000);

        return () => clearTimeout(timer);
      }, [accordionElement]);
    const invitaionSectionChanged = (value: any) => {
        setInvitaionSectionOpened(value);
    };
    // const  companies = ['Company 1', 'Company 2', 'Company 3']; 
    const [companies, setcompanies] = useState([]);
    const dispatch = useAppDispatch();
    const [SelectedCompany, setSelectedCompany] = useState<any>(null);

    useEffect(() => { 
        if(!isAccountPage){return;}
        dispatch(getOwnCompanies()); 
    }, [])

    useEffect(() => {
        if(!createOrganization && !addCategorydata && !updateCategorydata && !deleteCategorydata && !updateNameCompany){
            return;
        }
         
        dispatch(getOwnCompanies()); 

    }, [createOrganization,addCategorydata, updateCategorydata, deleteCategorydata, updateNameCompany ])
    
    useEffect(() => {
        if(!getOwnCompaniesdata && !ClientOrganizations) return;
        if(isAccountPage){
            setcompanies(getOwnCompaniesdata); 
            if(!SelectedCompany) return;
            const selectedComp = getOwnCompaniesdata?.find((company:any) => company?.id === SelectedCompany?.company_id);
            setSelectedCompany({
            company_id: selectedComp?.id, 
            company_name: selectedComp?.company_name,
            company_categ: selectedComp?.categories  // Including the categories in the state
            });
            return;
        }
        setcompanies(ClientOrganizations); 

    }, [getOwnCompaniesdata,ClientOrganizations])
    const [currentCompanyId, setCurrentCompanyId] = useState('');

    useEffect(() => {
        if (!companyId) {
            return;
        }

        selectedCompany(companyId);
    }, [companyId])
    
    const  selectedCompany = (company_id: any)=>{
        
        setCurrentCompanyId(company_id);
    }

    useEffect(() => {
        if ( currentCompanyId ) {
            dispatch(fetchSiteList({currentCompanyId,isAccountPage})); 
            if(!CompanyUsers[currentCompanyId]) {return;}
            setCurrentCompanyUsers(CompanyUsers[currentCompanyId]);
            return;
        }
   
    }, [currentCompanyId])




    useEffect(() => {
        if ( !SelectedCompany?.company_id  ) {
            return;
        }
        const _users = CompanyUsers[SelectedCompany?.company_id] ?? [];
        setCurrentCompanyUsers(_users);
        return;
   
    }, [SelectedCompany,CompanyUsers])
    

    useEffect(() => {
        if (  SelectedCompany?.company_name ) {
            dispatch(fetchSiteList({currentCompanyId:SelectedCompany?.company_id,isAccountPage})); 
        }
    }, [siteAdded])


    const [addSiteModal, setAddSiteModal] = useState(false);
    const [removeCompanyModal, setRemoveCompanyModal] = useState(false);
    const [settingsModal, setSettingsModal] = useState(false);

    const changeFormState = (): void =>{
        setAddSiteModal(!addSiteModal);
      } 
  const siteLists  = useAppSelector((state) => state.siteList.data, shallowEqual);
//   const loadingSiteList = useAppSelector((state) => state.siteList.loading);
  const { isLoading } = useAppSelector((state) => state.payment);
  const { websites } = useAppSelector((state) => state.payment.data.metadata);
  const loading = useAppSelector((state) => state.siteList.loading);

  const canDisplayButton = !( websiteCount  >= Number(websites)) && !isLoading;
    
  const [addNewCateg, setAddNewCateg] = useState(false);
  const [addNewCategError, setAddNewCategError] = useState('');
  const [ updatecategErrorMsg, setUpdatecategErrorMsg] = useState('');
  const [ updateCompanyNameErrorMsg, setUpdateCompanyNameErrorMsg] = useState('');
  const [newCategVal, setNewCategVal] = useState('');
  const [updatecateg, setUpdatecateg] = useState<any>({});
  const [newCompanyNameVal, setNewCompanyNameVal] = useState<any>();

  useEffect(() => {
    setNewCompanyNameVal(SelectedCompany?.company_name);
  }, [SelectedCompany])
  
  
  const removeOrganisation = (id: any) => {
        dispatch(deleteClientFromOrganisation({
            company_id: id,
        }));
        };

useEffect(() => {
    if(!settingsModal || !SelectedCompany.company_id){
        return;
    }
    
    dispatch(getOwnCompanyUsers({
        company_id: SelectedCompany.company_id,
    }));

}, [settingsModal,removeUserFromComp])

const [currentCompanyUsers, setCurrentCompanyUsers] = useState([]);

const [editPermission,setEditPermission ] = useState<any>(null);
const [companyRole,setCompanyRole ] = useState<any>('');
const [companyPermissions,setCompanyPermission ] = useState<any>([]);
const [filteredCateg,setFilteredCateg ] = useState<any>([]);

useEffect(() => {
    if(!SelectedCompany?.company_categ){
        return;
    }
    const formattedCategories = SelectedCompany?.company_categ?.map(({ id, category_name }:any) => ({
        label: category_name,
        value: id
    }));
    
    setFilteredCateg(formattedCategories);

}, [SelectedCompany?.company_categ])

const allowedRolesToEdit = ['admin', 'editor'];


    return (<>
            <Accordion
                chevronPosition="left"
                variant="separated"
                radius={'lg'}
                multiple={false}
                defaultValue={ isAccountPage ? "manage_roles" : "" }
                tabIndex={-1}
                onChange={invitaionSectionChanged}
                chevron={<ChevronUp className={styles.circelBorder} />}

            >
                {/* {
                    isAccountPage ? null : <Accordion.Item value={'manage_users'}>
                    <Accordion.Control>
                        <Group position="apart">
                            <Text weight={500}>Manage Users</Text>
                            <UnstyledButton
                                className={styles.link}
                                onClick={() => {
                                    navigateToPayment();
                                }}>
                                Upgrade your plan to add more users 10 seats of 10 users
                            </UnstyledButton>
                        </Group>
                    </Accordion.Control>
                    <Accordion.Panel>
                        <UsersListComponent />
                    </Accordion.Panel>
                    </Accordion.Item>
                } */}
                {
                    isAccountPage ?
                        null
                        :
                        <>
                        {/* <Accordion.Item value={'manage_invetation'}>
                            <Accordion.Control>
                                <Group position="apart">
                                    <Text weight={500}>Requests</Text>
                                </Group>
                            </Accordion.Control>
                            <Accordion.Panel>
                                <InvitationsListComponent organization_id={organizationId ?? ""}  invitaionSectionOpened={invitaionSectionOpened}   />
                            </Accordion.Panel>
                        </Accordion.Item> */}
                        {/* <Accordion.Item value={'organisationCompanies'}>
                            <Accordion.Control>
                                <Group position="apart">
                                    <Text weight={500}>Manage Companies</Text>
                                </Group>
                            </Accordion.Control>
                            <Accordion.Panel> */}
                                {/* <CompaniesWithinOrganisation amIAdmin={amIAdmin} organizationId={organizationId ?? ""} isAccountPage={isAccountPage} /> */}
                            
                                {
                                    companies && companies.length > 0 ?
                                <Accordion
                                    chevronPosition="left"
                                    variant="separated"
                                    radius={'lg'}
                                    multiple={false}  
                                    chevron={<ChevronUp className={styles.circelBorder} 
                                    onChange={(val:any)=> selectedCompany(val)}

                                    />}
                                    >
                                    {companies?.map((company:any, index) => (
                                        <Accordion.Item value={company.id} key={index}>
                                        <Accordion.Control onClick={()=>{
                                                                selectedCompany(company.id);  
                                                                setSelectedCompany({company_categ:company.categories}); 
                                                            }}>
                                            <Flex align={'center'} justify={'space-between'}>
                                                <Text weight={500}>{company.company_name}</Text>
                                                {/* {
                                                    company?.categories?.map((categ:any, index:number) => (

                                                        <Badge  variant="light">
                                                            {categ.category_name}
                                                        </Badge>

                                                    ))
                                                } */}
                                                <Flex>
                                                {  allowedRolesToEdit.includes(company?.role)
                                                // || company?.companyPermissions?.includes('add-site') 
                                                ?
                                                    <Tooltip label={!loading && !canDisplayButton  ? 'The Maximum Site Limit Has Been Reached' : 'Add Website'}  >
                                                        <UnstyledButton
                                                        disabled={!canDisplayButton}
                                                        style={{ cursor: !canDisplayButton ? 'not-allowed' : 'pointer' }}
                                                        className={styles['delete-btn']} onClick={(e)=>{
                                                            setAddSiteModal(true); 
                                                            setSelectedCompany({company_id:company.id, company_name: company.company_name,company_categ:company.categories}); 
                                                            e.stopPropagation();
                                                        }
                                                        }
                                                            aria-label='Add Website'
                                                            >
                                                            <Plus color="#A80000" /> Add Website
                                                        </UnstyledButton>
                                                    </Tooltip> :
                                                    null

                                                }
                                                    {/* <Tooltip label="Delete Company" >
                                                        <UnstyledButton className={styles['delete-btn']} onClick={(e)=>{
                                                            setSelectedCompany({company_id:company.id, company_name: company.company_name}); 
                                                            setRemoveCompanyModal(true); 
                                                            e.stopPropagation();
                                                        }
                                                        }
                                                            aria-label='Delete Company'
                                                            >
                                                            <Trash2 color="#A80000" /> Delete
                                                        </UnstyledButton>
                                                    </Tooltip> */}
                                                {  allowedRolesToEdit.includes(company?.role)
                                                // || company?.companyPermissions?.includes('edit-company-name') 
                                                ?

                                                    <Tooltip label="Company Settings" >
                                                        <UnstyledButton className={styles['delete-btn']} onClick={(e)=>{
                                                            setSelectedCompany({company_id:company.id, company_name: company.company_name,
                                                                                company_categ:company.categories,
                                                                                role:company.role,
                                                                                companyPermissions:company.companyPermissions 
                                                                            }); 
                                                            setSettingsModal(true); 
                                                            e.stopPropagation();
                                                        }
                                                        }
                                                            aria-label='Company Settings'
                                                            >
                                                            <Settings color="#A80000" /> Settings
                                                        </UnstyledButton>
                                                    </Tooltip>
                                                    :
                                                    null
                                                    }
                                                    <Tooltip label="leave organisation" >

                                                  <UnstyledButton className={styles['delete-btn']} onClick={() => removeOrganisation(company.id)}
                                                        aria-label='leave organisation'
                                                        >
                                                        <LogIn color="#A80000" /> Leave
                                                    </UnstyledButton>
                                                    </Tooltip>
                                                </Flex>
                                            </Flex>
                                        </Accordion.Control>
                                        <Accordion.Panel>
                                            {/* <Flex my={'15px'}>
                                                <Select
                                                width={'40%'}
                                                color='black'

                                                //  label="Your favorite library"
                                                placeholder="Chose Category"
                                                data={filteredCateg ?? []}
                                                />         
                                            </Flex> */}

                                            <WebsitesListComponent
                                            isAccountPage={isAccountPage}
                                            companyId={company.id}
                                            siteUUID={siteUUID}
                                            panel={panel}
                                            />
                                        </Accordion.Panel>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                                    :   ( <Flex w={"100%"} justify={"center"} align={"center"}>No Companies Yet.</Flex> )
                                }
                            {/* </Accordion.Panel>
                        </Accordion.Item> */}
                        </>
                }
                {
                    isAccountPage ?

                    // <Accordion.Item value="manage_roles">
                    // <Accordion.Control>
                    //     <Group position="apart">
                    //     <Text weight={500}>Manage Companies</Text>
                    //     </Group>
                    // </Accordion.Control>
                    // <Accordion.Panel>
                        <Accordion
                        chevronPosition="left"
                        variant="separated"
                        radius={'lg'}
                        multiple={false}  
                        chevron={<ChevronUp className={styles.circelBorder} 
                        onChange={(val:any)=> selectedCompany(val)}
                        />}
                        defaultValue={ companyId }
                        >
                        {companies?.map((company:any, index) => (
                            <Accordion.Item value={company.id} key={index}>
                            <Accordion.Control onClick={()=>{
                                                                selectedCompany(company.id);  
                                                                setSelectedCompany({company_categ:company.categories}); 
                                                            }}>
                                <Flex align={'center'} justify={'space-between'}>
                                        <Tooltip multiline={true} label={wrapText(company.company_name)}>
                                            <Text weight={500}>{displayName(company.company_name)}</Text>
                                        </Tooltip>
                                    {/* {
                                        company?.categories?.map((categ:any, index:number) => (

                                            <Badge  variant="light">
                                                {categ.category_name}
                                            </Badge>

                                        ))
                                    } */}
                                    <Flex>
                                        <Tooltip label={!canDisplayButton ? 'The Maximum Site Limit Has Been Reached' : 'Add Website'} >
                                            <UnstyledButton 
                                                style={{ cursor: !canDisplayButton ? 'not-allowed' : 'pointer' }}
                                                disabled={!canDisplayButton}
                                                className={styles['delete-btn']} onClick={(e)=>{
                                                setAddSiteModal(true); 
                                                setSelectedCompany({company_id:company.id, company_name: company.company_name,company_categ:company.categories}); 
                                                e.stopPropagation();
                                            }
                                            }
                                                aria-label='Add Website'
                                                >
                                                <Plus color="#A80000" /> Add Website
                                            </UnstyledButton>
                                        </Tooltip>
                                        <Tooltip label="Delete Company" >
                                            <UnstyledButton className={styles['delete-btn']} onClick={(e)=>{
                                                setSelectedCompany({company_id:company.id, company_name: company.company_name}); 
                                                setRemoveCompanyModal(true); 
                                                e.stopPropagation();
                                            }
                                            }
                                                aria-label='Delete Company'
                                                >
                                                <Trash2 color="#A80000" /> Delete
                                            </UnstyledButton>
                                        </Tooltip>

                                        <Tooltip label="Company Settings" >
                                            <UnstyledButton className={styles['delete-btn']} onClick={(e)=>{
                                                setSelectedCompany({company_id:company.id, company_name: company.company_name,company_categ:company.categories}); 
                                                setSettingsModal(true); 
                                                e.stopPropagation();
                                            }
                                            }
                                                aria-label='Company Settings'
                                                >
                                                <Settings color="#A80000" /> Settings
                                            </UnstyledButton>
                                        </Tooltip>

                                    </Flex>
                                </Flex>
                            </Accordion.Control>
                            <Accordion.Panel>
                                {/* <Flex my={'15px'}>
                                    <Select
                                    width={'40%'}
                                    color='black'
                                    //  label="Your favorite library"
                                    placeholder="Chose Category"
                                    data={filteredCateg ?? []}
                                    />         
                                </Flex> */}

                                <WebsitesListComponent
                                isAccountPage={isAccountPage}
                                companyId={company.id}
                                siteUUID={siteUUID}
                                panel={panel}
                                />
                            </Accordion.Panel>
                            </Accordion.Item>
                        ))}
                        </Accordion>
                    // </Accordion.Panel>
                    // </Accordion.Item>
                    
                    
                        :
                        null

                }
                {/* {
                    isAccountPage ?
                        null
                        :
                        <Accordion.Item value={'permissiom'}>
                            <Accordion.Control>
                                <Group position="apart">
                                    <Text weight={500}>Permissiom</Text>
                                </Group>
                            </Accordion.Control>
                            <Accordion.Panel>
                                <Permissions />
                            </Accordion.Panel>
                        </Accordion.Item>
                } */}
            </Accordion>

            <Modal opened={addSiteModal} close={()=>{setAddSiteModal(false)}} zIndex={1000} withCloseButton={false} size={450} padding={20}>
                <Group align={'center'} position={'center'} p={28}>
                <Title order={3}>Add website To :<strong>{displayName(SelectedCompany?.company_name , 30)}</strong>
                    </Title>
                </Group>
                <AddSiteForm isAccountPage={isAccountPage} companyId= {SelectedCompany?.company_id} changeFormState={changeFormState} listItems={siteLists} canDisplayButton={canDisplayButton} style={{flexDirection: 'column'}} /> 

            </Modal>


            <Modal opened={removeCompanyModal} close={()=>{setRemoveCompanyModal(false)}} zIndex={1000} withCloseButton={false} size={450} padding={0}>
                <Group align={'center'} position={'center'} p={28}>
                <Title order={3}>Remove Company : 
                    {/* <Tooltip multiline={true} label={wrapText(SelectedCompany?.company_name ?? "")}> */}
                        <Text weight={500}>{displayName(SelectedCompany?.company_name ?? "")}</Text>
                    {/* </Tooltip> */}
                 </Title>
                <Text align={'center'}>
                    Are You Sure You Want to Delete This Company
                </Text>
                </Group>
                <div className={classNames(styles['btn-group'])}>
                {/* <UnstyledButton onClick={()=>{setRemoveCompanyModal(false)}} className={classNames(styles['action-btn'])}>
                    Cancel
                </UnstyledButton> */}
                <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
                <UnstyledButton
                    onClick={() => {
                    dispatch(deleteOrganizationfun({company_id:SelectedCompany?.company_id ,
                        submitCallback: () => {
                            const siteInStorage = JSON.parse(localStorage.getItem('selectedSite') ?? "")
                            if ( siteInStorage?.company_id == SelectedCompany?.company_id  || selectedSiteData?.company_id == SelectedCompany?.company_id  ) {
                                dispatch(selectedSite({ selectedSiteData: null }));
                                localStorage.removeItem('selectedSite')
                            }
                            showAlert({
                              id: 'company-delete',
                              title: 'Delete Company',
                              message: `${SelectedCompany?.company_name} Has Been Deleted Successfully.`,
                              variant: 'success',
                              autoClose: 2000
                            });
                          },
                          errorCallback: (error: string) => {
                            showAlert({
                              id: error,
                              title: 'Delete Company',
                              message: error,
                              variant: 'error',
                              autoClose: 2000
                            });
                          }
                    }));
                    setRemoveCompanyModal(false)
                    }}
                    className={classNames(styles['action-btn'])}>
                    Delete
                </UnstyledButton>
                </div>
            </Modal>



            <Modal opened={settingsModal} close={()=>{setSettingsModal(false)}} zIndex={1000} withCloseButton={false} size={800} padding={20}>
                <Group align={'center'} position={'center'} p={28}>
                    <Title order={3}>{SelectedCompany?.company_name} Settings </Title>
                </Group>
                
                <Tabs defaultValue="users" onTabChange={(e) => {  
                    setUpdatecateg({})
                    setAddNewCateg(false)
                 }}>
                    <Tabs.List>
                    {  isAccountPage  ?
                            <>
                                <Tabs.Tab value="users" icon={<Users size="0.8rem" />}>Users</Tabs.Tab>
                                {/* <Tabs.Tab value="categories" icon={<Tag size="0.8rem" />}>Categories</Tabs.Tab> */}
                            </>
                    :
                    null
                    }

                    {
                        isAccountPage ||  allowedRolesToEdit.includes(SelectedCompany?.role)
                        // || SelectedCompany?.companyPermissions?.includes('edit-company-name') 
                        ?
                             <Tabs.Tab value="company" icon={<AlignJustify size="0.8rem" />}>Company</Tabs.Tab>
                          : null
                    }
                    </Tabs.List>

                    {  isAccountPage  ?
                    <>
                    <Tabs.Panel value="users" pt="xs">
                    <Flex>

                    <Navbar height={600} p="xs" width={{ base: 300 }}>
                        <Navbar.Section mt="xs"><Users size="0.8rem" /> Users</Navbar.Section>

                        <Navbar.Section grow component={ScrollArea} mx="-xs" px="xs">
                        {
                                currentCompanyUsers?.map((user:any, index:number) => (
                                    <Flex 
                                    pl={"lg"} 
                                    w={'100%'}
                                    aria-label={user.user_email} 
                                    className={styles['categBtn']} 
                                    justify={'space-between'}
                                    >
                                        <Flex
                                            justify={'flex-start'}
                                            direction= {'column'}
                                        >
                                            <strong aria-label='user name'>{ user.user_name ?? '' }</strong>
                                            <Text
                                                w={'100%'}
                                                ml={'10px'}
                                            >
                                                {user.user_email}
                                            </Text>
                                        </Flex>
                                        <div style={{display:'flex'}}>
                                                <UnstyledButton  
                                                    style={{marginRight:'15px'}}
                                                    onClick={() => { 
                                                        setEditPermission({tenant_id: user.user_tenant_id ,company_id:user.company_id});
                                                        setCompanyRole(user.permissions);
                                                    }} 
                                                    >
                                                        <Edit size={20}/>
                                                </UnstyledButton>
                                                
                                                <UnstyledButton  
                                                    onClick={() => { 
                                                        if (window.confirm("Are you sure you want to remove this user from the company?")) {
                                                            dispatch(removeUserFromCompany({tenant_id: user.user_tenant_id, company_id: user.company_id}));
                                                        }
                                                        // dispatch(removeUserFromCompany({tenant_id: user.user_tenant_id ,company_id:user.company_id})) ;
                                                    }
                                                } 
                                                    >
                                                        <Trash2 size={20}/>
                                                </UnstyledButton>

                                        </div>

                                    </Flex>
                                    ))
                        }
                        </Navbar.Section>
                        </Navbar>
                            {
                                editPermission?.tenant_id  ?
                                <div>
                                <Navbar height={200} p="xs" width={{ base: 300 }}>
                                        <>
                                            <Title order={3}>Assign Company Role</Title>
                                            <Select
                                                label="Company roles"
                                                placeholder="Company roles"
                                                data={[
                                                   {label: 'Viewer',value:'viewer'},
                                                   {label:'Editor',value:'editor'},
                                                   {label:'Admin',value:'admin'},
                                                ]}
                                                aria-label="Company roles"
                                                className={styles.settingSelect}
                                                onChange={(e) => { e && setCompanyRole(e) }}
                                                value={companyRole}
                                            />
                                            <UnstyledButton 
                                                className={styles['saveCategBtn']} 
                                                pl={"sm"} w={'100%'}  
                                                onClick={() => {
                                                    if(!companyRole){alert('you should select a role'); return;}; 
                                                        dispatch(assignComanyRole({tenant_id:editPermission.tenant_id,company_id:editPermission.company_id,role:companyRole}));
                                                        showAlert({
                                                            id: 'role-updated',
                                                            title: 'Role Assigned',
                                                            message: 'Role Assigned successfully',
                                                            variant: 'success',
                                                            isAccessible:true
                                                          });
                                                    }} 
                                                aria-label='Assign a Role' 
                                                style={{paddingBottom:'15px'}}
                                            >
                                                Assign Role
                                            </UnstyledButton>
                                        </>
                                </Navbar> 

                                {/* <Navbar height={200} p="xs" width={{ base: 300 }}>
                                        <>
                                            <Title order={3}>Assign Company Permission</Title>
                                         
                                            <MultiSelect
                                                data={[
                                                    {label:'Add Site',value:'add-site'},
                                                    {label:'Edit Company Name',value:'edit-company-name'},
                                                ]}                                                
                                                // data={tags[org.organization]?.tags || []} // Show all tags at the organization level
                                                placeholder="Company Permissions"
                                                aria-label="Company Permissions"
                                                value={companyPermissions}
                                                onChange={setCompanyPermission}
                                                creatable
                                                searchable
                                                getCreateLabel={(query) => `+ Create "${query}"`}
                                                onCreate={(query) => {
                                                const newTag = query.trim();
                                                setCompanyPermission((current:any) => [...current, newTag]);
                                                return newTag; // Return the new tag string
                                                }}
                                                className={styles.settingSelect}
                                                // style={{ marginTop: '10px', marginBottom: '10px' }}
                                                />
                                            <UnstyledButton 
                                                className={styles['saveCategBtn']} 
                                                pl={"sm"} w={'100%'}  
                                                onClick={() => {
                                                    if(!companyPermissions){alert('you should set a permission'); return;}; 
                                                        dispatch(assignComanyPermission({tenant_id:editPermission.tenant_id,company_id:editPermission.company_id,permission:companyPermissions}));
                                                        setEditPermission(null); 
                                                    }} 
                                                aria-label='Assign a Role' 
                                                style={{paddingBottom:'15px'}}
                                            >
                                                Assign Permission
                                            </UnstyledButton>
                                        </>
                                </Navbar>  */}
                                
                                </div>
                                :
                                null
                            }

                    </Flex>


                        
                    </Tabs.Panel>

                    {/* <Tabs.Panel value="categories" pt="xs">
                        <Flex>

                    <Navbar height={600} p="xs" width={{ base: 300 }}>
                        <Navbar.Section mt="xs"><Tag size="0.8rem" /> Categories</Navbar.Section>

                        <Navbar.Section grow component={ScrollArea} mx="-xs" px="xs">

                        
                           {
                                SelectedCompany?.company_categ?.map((categ:any, index:number) => (
                                    <Flex 
                                    pl={"lg"} 
                                    w={'100%'}
                                    aria-label={categ.category_name} 
                                    className={styles['categBtn']} 
                                    >
                                        <Text
                                            w={'100%'}
                                        >
                                            {categ.category_name}

                                        </Text>
                                        <div style={{display:'flex'}}>
                                                <UnstyledButton  
                                                    style={{marginRight:'15px'}}
                                                    onClick={() => { 
                                                        setUpdatecateg({id: categ.id ,value:categ.category_name});
                                                    }} 
                                                    >
                                                        <Edit size={20}/>
                                                </UnstyledButton>
                                                
                                                <UnstyledButton  
                                                    onClick={() => { 
                                                        dispatch(deleteCategory({category_id: categ.id , 
                                                        
                                                            submitCallback: () => {
                                                                setUpdatecateg({})
                                                                setAddNewCateg(false)
                                                                dispatch(resetState())
                                                            },
                                                            errorCallback: (error: string) => {
                                                            }
                                                        
                                                        })) ;
                                                    }} 
                                                    >
                                                        <Trash2 size={20}/>
                                                </UnstyledButton>

                                        </div>

                                    </Flex>
                                    ))
                           }
                        </Navbar.Section>

                        <Navbar.Section>
                            {
                                addNewCateg ?
                                <>
                                    <TextInput
                                        error={addNewCategError}
                                        placeholder="Category Name"
                                        label="Category Name"
                                        withAsterisk
                                        style={{paddingBottom:'15px'}}
                                        onChange={(e:any)=>{
                                         setNewCategVal(e.target.value)}}
                                    />
                                    <UnstyledButton 
                                        className={styles['saveCategBtn']} 
                                        pl={"sm"} w={'100%'}  
                                        onClick={() => { if(!newCategVal)return; dispatch(addCategory({category_name:newCategVal,company_id:SelectedCompany?.company_id ,
                                            submitCallback: () => {
                                                setAddNewCategError("")
                                                showAlert({
                                                  id: 'category-added',
                                                  title: 'Add Category',
                                                  message: `${newCategVal} Has Been Added Successfully.`,
                                                  variant: 'success',
                                                  autoClose: 2000
                                                });
                                                setUpdatecateg({})
                                                setAddNewCateg(false)
                                                dispatch(resetState())
                                            },
                                            errorCallback: (error: string) => {
                                            setAddNewCategError(error)
                                            showAlert({
                                                id: error,
                                                title: 'Something went wrong!!',
                                                message: error,
                                                variant: 'error',
                                                autoClose: 2000
                                            });
                                            }
                                        })); }} 
                                        aria-label='Save Category' 
                                        style={{paddingBottom:'15px'}}
                                    >
                                        <Save  size="1rem" />
                                        Save
                                    </UnstyledButton>
                                    <Space h={"sm"} />
                                </>
                                :
                                null
                            }
                            <UnstyledButton className={styles['addCategBtn']} pl={"lg"} w={'100%'}  onClick={() => {setAddNewCateg(!addNewCateg)}} aria-label='Add Category' >
                                    <Plus  size="1rem" />
                                    Add Category
                            </UnstyledButton>
                        </Navbar.Section>
                        </Navbar>
                        {
                            updatecateg.value ?
                            <Navbar height={600} p="xs" width={{ base: 300 }}>
                                    <>
                                        <TextInput
                                            error={updatecategErrorMsg}
                                            placeholder="Category name"
                                            label="Category name"
                                            withAsterisk
                                            style={{paddingBottom:'15px'}}
                                            value={updatecateg?.value}
                                            onChange={(e:any)=>{
                                                setUpdatecateg((prevState:any) => ({
                                                    ...prevState,  // Spread the existing state to keep other properties
                                                    value: e.target.value  // Update only the value property
                                                  }));
                                        }}
                                        />
                                        <UnstyledButton 
                                            disabled={loadingupdateCategory}
                                            className={styles['saveCategBtn']} 
                                            pl={"sm"} w={'100%'}  
                                            onClick={() => {
                                                 if(!updatecateg.value)return; 
                                                 dispatch(updateCategory({category_id:updatecateg.id,new_category_name:updatecateg.value ,
                                                    submitCallback: () => {
                                                        setUpdatecategErrorMsg("")
                                                        showAlert({
                                                            id: 'category-update',
                                                            title: 'Update Category',
                                                            message: `${updatecateg?.value} Has Been Updated Successfully.`,
                                                            variant: 'success',
                                                            autoClose: 2000
                                                        });
                                                        setUpdatecateg({})
                                                        setAddNewCateg(false)
                                                        dispatch(resetState())
                                                        },
                                                        errorCallback: (error: string) => {
                                                        setUpdatecategErrorMsg(error)
                                                        showAlert({
                                                            id: error,
                                                            title: 'Update Category',
                                                            message: error,
                                                            variant: 'error',
                                                            autoClose: 2000
                                                        });
                                                        }
                                                }));
                                                }} 
                                            aria-label='update Category' 
                                            style={{paddingBottom:'15px'}}
                                        >
                                            <Save  size="1rem" />
                                            Update
                                        </UnstyledButton>
                                    </>
                            </Navbar> :
                            null
                        }

                        </Flex>

                    </Tabs.Panel> */}
                    </>
                      :
                      null
                    }
                    {
                        isAccountPage ||  allowedRolesToEdit.includes(SelectedCompany?.role) 
                        // || SelectedCompany?.companyPermissions?.includes('edit-company-name') 
                        ?

                    <Tabs.Panel value="company" pt="xs">
                        <TextInput
                            error={updateCompanyNameErrorMsg}
                            placeholder="Company name"
                            label="Company name"
                            withAsterisk
                            style={{paddingBottom:'15px'}}
                            value={newCompanyNameVal}
                            onChange={(e:any)=>{
                                setNewCompanyNameVal(e.target.value)
                            }}
                        />
                        <UnstyledButton 
                            className={styles['saveCategBtn']} 
                            pl={"sm"} w={'100%'}  
                            onClick={() => { if(!newCompanyNameVal)return; dispatch(updateCompanyName({new_company_name:newCompanyNameVal,company_id:SelectedCompany?.company_id,isAccountPage ,
                                successMessage: () => {
                                    setUpdateCompanyNameErrorMsg("")
                                    showAlert({
                                        id: 'category-update',
                                        title: 'Update Category',
                                        message: `${newCompanyNameVal} Has Been Updated Successfully.`,
                                        variant: 'success',
                                        autoClose: 2000
                                    });
                                   
                                    },
                                    errorCallback: (error: string) => {
                                    setUpdateCompanyNameErrorMsg(error)
                                    showAlert({
                                        id: error,
                                        title: 'Update Category',
                                        message: error,
                                        variant: 'error',
                                        autoClose: 2000
                                    });
                                    }
                            })); }} 
                            aria-label='Save Category' 
                            style={{paddingBottom:'15px'}}
                        >
                            <Save  size="1rem" />
                            Save
                        </UnstyledButton>

                    </Tabs.Panel>
                        : null
                    }

                </Tabs>

            </Modal>
    
            </>

    );
}
export default MainAccordion

function UsersListComponent() {
    const navigate = useNavigate();

    const [expandedRows, setExpandedRows] = useState<string[]>([]);
    const [companyUsers, setCompanyUsers] = useState([
        { id: '1', name: 'Michael Holz', email: 'michael@email.com', date: '04/10/2013', role: 'Admin', status: 'active', img: '' },
        { id: '2', name: 'Paula Wilson', email: 'paula@email.com', date: '05/08/2014', role: 'Siteowner', status: 'active', img: '' },
        { id: '3', name: 'Antonio Moreno', email: 'antonio@email.com', date: '11/05/2015', role: 'Publisher', status: 'suspended', img: '' },
        { id: '4', name: 'Mary Saveley', email: 'mary@email.com', date: '06/09/2016', role: 'Reviewer', status: 'active', img: '' },
        { id: '5', name: 'Martin Sommer', email: 'martin@email.com', date: '12/08/2017', role: 'Moderator', status: 'pending', img: '' },
        { id: '6', name: 'Frank Gomez', email: 'Frank@email.com', date: '10/05/2017', role: 'inactive', status: 'pending', img: '' },

    ]);
    const { showAlert } = useAlert();
    const getStatusDot = (status: any) => {
        switch (status) {
            case 'active':
                return <span className={styles.statusDot} style={{ backgroundColor: 'green' }}></span>;
            case 'suspended':
                return <span className={styles.statusDot} style={{ backgroundColor: 'red' }}></span>;
            case 'pending':
                return <span className={styles.statusDot} style={{ backgroundColor: 'orange' }}></span>;
            default:
                return null;
        }
    };

    const getInitials = (name: any) => {
        return name ? name.split(' ').map((n: any) => n[0]).join('').slice(0, 2).toUpperCase() : '';
    };

    const toggleRow = (id: string) => {
        if (expandedRows.includes(id)) {
            setExpandedRows(expandedRows.filter(rowId => rowId !== id));
        } else {
            setExpandedRows([...expandedRows, id]);
        }
    };
    const dispatch = useAppDispatch();

    const initialUsers: User[] = [
        { id: '1', name: 'Michael Holz', email: 'michael@email.com', role: 'Admin', status: 'Inactive', img: '' },
        { id: '2', name: 'Paula Wilson', email: 'paula@email.com', role: 'Siteowner', status: 'Active', img: '' },
        { id: '3', name: 'Antonio Moreno', email: 'antonio@email.com', role: 'Publisher', status: 'Pending', img: '' },
        { id: '4', name: 'Mary Saveley', email: 'mary@email.com', role: 'Reviewer', status: 'Active', img: '' },
        { id: '5', name: 'Martin Sommer', email: 'martin@email.com', role: 'Moderator', status: 'Pending', img: '' },
        { id: '5', name: 'Frank Gomez', email: 'Frank@email.com', role: 'inactive', status: 'Inactive', img: '' },
    ];
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [users, setUsers] = useState<User[]>(initialUsers);
    const [opened, { open, close }] = useDisclosure(false);

    // Add type annotations for index, field, and value
    const handleUpdate = (index: number, field: keyof User, value: string): void => {
        const updatedUsers = [...users];
        updatedUsers[index][field] = value;
        setUsers(updatedUsers);
    };
    const [c] = useTranslation('common');
    const [t] = useTranslation('account');

    const { data } = useAppSelector((state) => state.user, shallowEqual);

    const initialValues: Record<string, string> = {
        firstName: '',
        lastName: '',
    };
    const form = useForm({
        initialValues: initialValues,
        validate: (values) => {

            const verify = yupResolver(validationFormSchema)
            const result = verify(values)
            // console.log(result);
            if (Object.keys(result).length > 0) {
                setNeedFocus(true)
            } else {
                setNeedFocus(false)
            }
            return result
        }
    });
    const { setNeedFocus } = useFormFocus({ formErrors: form.errors });
    const validationFormSchema = yup.object().shape({
        firstName: validationPattern.firstName,
        lastName: validationPattern.lastName,
    });
    const onSubmitHandler = async (values: Record<string, string>): Promise<void> => {
        dispatch(updateCurrent({ data: values, successMessage: successMessage }));
    };
    const successMessage = (): void => {
        showAlert({
            id: 'GeneralInfo',
            title: c('Success'),
            message: `${t('generalInfoSuccess')}`,
            variant: 'success',
        });
    };
    return (
        <Accordion
            chevronPosition="left"
            variant="separated"
            radius={'lg'}
            multiple={true}  // Allow multiple accordion tabs to be open
        >
            {users.map((user, index) => (
                <Accordion.Item value={user.name} key={index}>
                    <Accordion.Control disabled={user.status === 'Pending'}>
                        <Group position="apart">
                            <Text weight={500}>{user.name}</Text>
                            <Badge
                                color={user.status === 'Active' ? 'green' : user.status === 'Inactive' ? 'red' : 'yellow'}
                            >
                                {user.status}
                            </Badge>
                            {
                                user.status === 'Pending' && (
                                    <Flex gap={"sm"}>
                                        <Button color='gray-light'  >
                                            Resend invite
                                        </Button>
                                        <Button color='dark-green'>
                                            Accept invite
                                        </Button>
                                    </Flex>
                                )
                            }

                        </Group>
                        {
                            user.status == "Pending" ? null
                                :
                                <Text size="sm" color="dimmed">
                                    Role: {user.role}
                                </Text>
                        }
                    </Accordion.Control>
                    <Accordion.Panel >
                        <Card shadow="sm" padding="lg" radius="md" withBorder mt={"sm"} bg={"#f8f9fa"}>


                            <div className={styles.settings}>
                                <Flex w={"100%"} justify={"space-between"} align={"center"}>
                                    <strong style={{ marginBottom: "15px", display: "block" }}>Settings for {user.name}</strong>
                                    {user?.status == 'Inactive' && <Button >Re Activate User</Button>}
                                </Flex>
                                <div
                                    style={{
                                        pointerEvents: user?.status === 'Inactive' ? 'none' : 'auto',
                                        opacity: user?.status === 'Inactive' ? 0.5 : 1,
                                        cursor: user?.status === 'Inactive' ? 'not-allowed' : 'pointer',
                                    }}
                                    className={styles['right-content']}>
                                    {/* <Title className={styles['second-heading']} color={'#264547'} mb={'18px'} order={1}>
                                                    {t('nav.accountDetails')}
                                                    </Title> */}
                                    {/* <p>{t('nav.accountDesrption')}</p> */}
                                    <form
                                        className={`${styles['general-info']}  roleForm`}
                                        onSubmit={form.onSubmit((values) => {
                                            onSubmitHandler(values);
                                            setNeedFocus(true);
                                        })}>
                                        {/* <Select
                                                    className={styles['dropdown-role']}
                                                    variant="primary"
                                                    withIcon
                                                    aria-label={`${c('combobox')}`}
                                                    value={userRole}
                                                    label={`${t('nav.role')}` }
                                                    data={rolesList}
                                                    onChange={(e) => { setUserRole(e  || "")  }}
                                                    />
                                                    <Space h={'md'} /> */}
                                        <TextInput
                                            autoComplete={'given-name'}
                                            label={`${t('firstName')}`}
                                            withAsterisk={true}
                                            placeholder={`${t('firstNamePlaceholder')}`}
                                            // {...form.getInputProps('firstName')}
                                            value={user.name}
                                        />
                                        <Space h={'md'} />
                                        <TextInput
                                            autoComplete={'family-name'}
                                            withAsterisk={true}
                                            label={`${t('lastName')}`}
                                            placeholder={`${t('lastNamePlaceholder')}`}
                                            // {...form.getInputProps('lastName')}
                                            value={user.name}

                                        />
                                        <Select
                                            label="Role"
                                            value={user.role}
                                            data={[
                                                'Admin',
                                                'Siteowner',
                                                'Publisher',
                                                'Reviewer',
                                                'Moderator',
                                                'inactive'
                                            ]}
                                            placeholder="Select Role"
                                            style={{ marginTop: '10px', marginBottom: '10px' }}
                                        />
                                        {/* <Space h={'md'} /> */}
                                        {/* <Flex direction={'column'} mb={'8px'}>
                                                    <span className={styles['info-label']}>{t('email')}</span>
                                                    {data.email}
                                                    </Flex> */}
                                        <Space h={'md'} />
                                        <TextInput
                                            disabled
                                            type='email'
                                            label={`Email`}
                                            placeholder={`Email`}
                                            {...form.getInputProps('email')}
                                            // value={data.email}
                                            value={user.email}

                                        />
                                        <Space h={'md'} />
                                        <Checkbox
                                            className={styles.notifyCheckbox}
                                            label="Send Email Notification When Audit Start or Complete"
                                            checked={true}
                                        // onChecked={(e) => setNotifications(e.target.checked)}
                                        />
                                        <Flex gap={'md'}>
                                            <Button onClick={() => form.clearErrors()} className={styles['form-btn']} type={'submit'}>
                                                {t('Save Changes')}
                                            </Button>
                                            {/* <Button
                                                color='gray'
                                                ariaLabel='Undo changes made'
                                                className={styles['form-btn']}
                                                onClick={() => {
                                                    form.setValues({ firstName: data.firstName, lastName: data.lastName });
                                                    form.clearErrors();
                                                }}
                                            >
                                                {t('nav.undoAccount')}
                                            </Button> */}

                                        </Flex>

                                    </form>
                                    {/* <div > */}
                                    {/* <form
                                        style={{ marginLeft: "50px" }}
                                        className={styles['password-info']}
                                        onSubmit={form.onSubmit((values) => {
                                            onSubmitHandler(values);
                                            setNeedFocus(true);
                                        })}>
                                        <PasswordInput
                                            withAsterisk={true}
                                            label={t('oldPassword')}
                                            placeholder={t('oldPasswordPlaceholder')}
                                            {...form.getInputProps('oldPassword')}
                                        />
                                        <Space h={'md'} />
                                        <PasswordInput
                                            withAsterisk={true}
                                            label={`${t('newPassword')}`}
                                            placeholder={`${t('newPasswordPlacholder')}`}
                                            {...form.getInputProps('password')}
                                        />
                                        <Space h={'md'} />
                                        <PasswordInput
                                            withAsterisk={true}
                                            label={`${t('confirmPassword')}`}
                                            placeholder={`${t('confirmPasswordPlacholder')}`}
                                            {...form.getInputProps('confirmPassword')}
                                        />
                                        <Space h={'md'} />
                                        <Button onClick={() => form.clearErrors()} className={styles['form-btn']} type={'submit'} loading={isLoading}>
                                            {t('changePassword')}
                                        </Button>
                                    </form> */}
                                    {/* </div> */}
                                </div>
                                <Space h={'md'} />
                                <Link to={"javascript:;"} className={styles.deleteAccount} onClick={open}> Delete User </Link>
                                <Link to={"javascript:;"} className={classNames(styles.deleteAccount, styles.deactivateAccount)} style={{ marginLeft: "20px" }} > Send Email To Change User Password</Link>
                                {user.status == "Active" && <Link to={"javascript:;"} className={classNames(styles.deleteAccount, styles.deactivateAccount)} style={{ marginLeft: "20px" }} > Deactivate User </Link>}
                                {user.status == 'Inactive' && <Link to={"javascript:;"} className={classNames(styles.deleteAccount, styles.deactivateAccount)} style={{ marginLeft: "20px" }} > Send Invite</Link>}
                            </div>

                        </Card>
                    </Accordion.Panel>
                </Accordion.Item>
            ))}
        </Accordion>
    );
}






type InvitaionsData = {
    invitation_date: string,
    company_id: string,
    company_name: string,
    organization_id: string,
    organization_name: string,
    company_owner_email: string,
    state: string,
    type: string
}





function InvitationsListComponent({ organization_id , invitaionSectionOpened }: { organization_id: string , invitaionSectionOpened:string | null}) {
    const initialInvitations: Invitation[] = [
        { companyName: 'Tech Corp', invitedUser: 'John Doe', status: 'Pending', date: '2024-09-10' },
        { companyName: 'Web Solutions', invitedUser: 'Jane Smith', status: 'Accepted', date: '2024-08-28' },
        { companyName: 'Innovate Labs', invitedUser: 'Alice Johnson', status: 'Declined', date: '2024-09-05' },
    ];

    const [invitations, setInvitations] = useState<Invitation[]>(initialInvitations);

    const handleAction = async (company_id: string, organization_id: string, action: 'Accept' | 'Decline') => {
        if (!company_id || !organization_id) {
            return;
        }

        if (action == 'Accept') {
            // try {

            const response = await apiInstance.post('reporttool/organisationlevel/company/accept-organization-invitation',
                {
                    organization_id,
                    company_id
                }
            )


            if (response?.status == 200) {
                fetchRequests();
            }

            return;
        }

        const response = await apiInstance.post('reporttool/organisationlevel/company/decline-organization-invitation',
            {
                organization_id,
                company_id
            }
        )

        if (response?.status == 200) {
            fetchRequests();
        }
    };

    const fetchRequests = async () => {
        try {

            const response = await apiInstance.post('reporttool/organisationlevel/organisation/get-organization-companies-requests', { organization_id })
            // console.log(response);

            if (response && !response?.data?.message) {
                return setDataRequests(response?.data)
            }
            setDataRequests([])
        } catch (error: any) {
            // console.log(error);
            setDataRequests([])
        }

    }
    const [dataRequests, setDataRequests] = useState<InvitaionsData[]>()
    useEffect(() => {
         if (!invitaionSectionOpened) {
            return;
        }

        fetchRequests();
    }, [organization_id , invitaionSectionOpened])


    return (
        <>
            <Accordion
                chevronPosition="left"
                variant="separated"
                radius={'lg'}
                multiple={true}  // Allow multiple accordion tabs to be open
            >

                { dataRequests  && dataRequests?.length > 0 ?

                dataRequests.map((invitation: InvitaionsData, index) => (
                    invitation.state != "pending" ? null :
                        <Accordion.Item value={invitation.company_owner_email} key={index}>
                            <Accordion.Control >
                                <Group position="apart">
                                    <Text weight={500}>{invitation.company_owner_email}</Text>
                                    <Badge
                                        color={
                                            'yellow'
                                        }
                                    >
                                        {invitation.state}
                                    </Badge>
                                </Group>

                            </Accordion.Control>
                            <Accordion.Panel >

                                <Card shadow="md" padding="lg" radius="md" withBorder key={index} style={{ marginBottom: '10px' }}>
                                    <Flex justify="space-between" align="center">
                                        {/* Date */}
                                        <Text size="sm" color="dimmed">
                                            {formatDateFromTimestamp(Number(invitation.invitation_date))}
                                        </Text>
                                        {/* Accept/Decline Buttons */}
                                        <Group>
                                            <Button onClick={() => handleAction(invitation.company_id, invitation.organization_id, 'Accept')}>
                                                Accept
                                            </Button>
                                            <Button color='gray' onClick={() => handleAction(invitation.company_id, invitation.organization_id, 'Decline')}>
                                                Decline
                                            </Button>
                                        </Group>
                                    </Flex>
                                </Card>

                            </Accordion.Panel>
                        </Accordion.Item>
                ))

                :
                <Flex w={"100%"} justify={"center"} align={"center"}>
                    <p >The Organisation Have No Requests</p>
                </Flex>
            }
            </Accordion>
        </>
    );
}



function CompaniesWithinOrganisation({ organizationId, isAccountPage , amIAdmin }: { organizationId: string, isAccountPage: boolean , amIAdmin:boolean}) {
    const dispatch = useAppDispatch();
    const { companies, loadingCompanies, OrgsJoined } = useAppSelector((state) => state.organization, shallowEqual);


    const isErrorObject = (obj: string) => {
        return typeof obj === 'object' && obj !== null && 'message' in obj;
    };

    useEffect(() => {
        if (organizationId) {
            dispatch(fetchCompanies({ organizationId })); 
        }
    }, [organizationId])
    const [opnedCompany, setOpnedCompany] = useState('');
    
    return loadingCompanies ?
        <Flex gap={"md"} >
            <AutomatedAuditLoader />
            <span> {'Getting organisation'}</span>
        </Flex>
        :

        <>
            {
                amIAdmin && Array.isArray(companies) && (
                    companies.map((company: any, index: any) => (
                        <p key={index}>{company?.company_name}</p>
                    ))
                )
            }

            {!amIAdmin && <Accordion
                chevronPosition="left"
                variant="separated"
                radius={'lg'}
                multiple={false}  // Allow multiple accordion tabs to be open
                onChange={(val: any) => setOpnedCompany(val)}
            >
                    <Accordion.Item value={OrgsJoined[0]?.external_company_id}>
                        <Accordion.Control >
                            <Group position="apart">
                                Websites
                            </Group>
                        </Accordion.Control>
                        <Accordion.Panel >
                            <WebsitesListComponent isAccountPage={isAccountPage} companyId={OrgsJoined[0].external_company_id} organisationId={organizationId} opnedCompany={opnedCompany} />

                        </Accordion.Panel>
                    </Accordion.Item>
            </Accordion>

            }
        
        </>
        
}
function WebsitesListComponent({ isAccountPage, organisationId, companyId, siteUUID, panel, opnedCompany }: { isAccountPage: boolean, organisationId?: string, companyId?: string, siteUUID?:string, panel?:string, opnedCompany?:any }) {
    const dispatch = useAppDispatch(); 


    // company ( current user ) website list.
    const { data: siteLists, loading: loadigSitesUser , deleted , error, companysitelist } = useAppSelector((state) => state.siteList, shallowEqual);
    // state for websites
    const [currentSiteLists, setcurrentSiteLists] = useState<any>([])



    // organization
    const { companyWebsites, loadingCompanyWebsites, } = useAppSelector((state) => state.organization, shallowEqual);
    const user = useAppSelector((state) => state.user.data, shallowEqual);
    const selectedSiteData = useAppSelector((state) => state.site.selectedSiteData, shallowEqual);

    // useEffect( () => {

    //     if ( isAccountPage  ) {
    //         dispatch(fetchSiteList(companyId)); 
    //         // dispatch(fetchCompanySiteList(companyId)); 

    //     }
    // }, [isAccountPage])

    

    // re comment this when organization page is there again.
    useEffect(() => {
        // setcurrentSiteLists([]);
        if (isAccountPage) {
            if (siteLists?.length >= 0) { // to double check when there is no site
                if(!companyId){
                    return;
                }
                setcurrentSiteLists(siteLists[companyId]);
            } 
            return;
        }

        if(!opnedCompany){
            return;
        }
        if (!isAccountPage && organisationId) {
            dispatch(getCompanyWebsies({ company_id: opnedCompany, organization_id: organisationId }));
        }
    }, [siteLists, isAccountPage, organisationId, opnedCompany]);
 
    

    useEffect(() => {        
        
        // if(isAccountPage){
        //     setcurrentSiteLists(siteLists);
        // }
        if(!companyId){return;}
        if(!isAccountPage){
            setcurrentSiteLists(siteLists[companyId]);
        }
        return;
    }, [siteLists])
    

    const [websites, setWebsites] = useState<any>([]);

    const navigate = useNavigate();
    // const { companyId } = useParams<{ companyId: string }>();
    const [t] = useTranslation('account');
    const isMobile = useMediaQuery('(max-width: 768px)'); // Media query for mobile devices

    const [allTags, setAllTags] = useState(Array.from(new Set(websites?.flatMap((site: any) => site.tags.split(',')))));
    const [filteredWebsites, setFilteredWebsites] = useState<Website[]>(websites);
    const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [expandedRows, setExpandedRows] = useState<string[]>([]); // Track expanded rows
    const [expandedMobileSettings, setExpandedMobileSettings] = useState<string[]>([]); // Track mobile settings expansion

    // useEffect(() => {
    //     setcurrentSiteLists(companysitelist)
    // }, [companysitelist])
    
    useEffect(() => {
        if (selectedTags.length === 0) {
            setFilteredWebsites(websites);
        } else {
            setFilteredWebsites(websites.filter((site: any) =>
                selectedTags.every(tag => site.tags.includes(tag))
            ));
        }
    }, [selectedTags, websites]);

    const toggleRow = (id: string) => {
        if (expandedRows.includes(id)) {
            setExpandedRows(expandedRows.filter(rowId => rowId !== id));
        } else {
            setExpandedRows([...expandedRows, id]);
        }
    };

    const toggleMobileSettings = (id: string) => {
        if (expandedMobileSettings.includes(id)) {
            setExpandedMobileSettings(expandedMobileSettings.filter(rowId => rowId !== id));
        } else {
            setExpandedMobileSettings([...expandedMobileSettings, id]);
        }
    };

    const items = useMemo(() => [
        { title: t('Companies'), href: -2 },
        { title: t('List Of Users'), href: -1 }
    ]?.map((item, index) => (
        <Link to={"#"} key={index} style={{ color: "black" }} onClick={() => navigate(Number(item?.href))}>
            {item.title}
        </Link>
    )), [t, navigate]);

    const [tags, setTags] = useState([
        'Sport',
        'Social',
        'Event',
        'Culture'
    ]);

    const [isModalOpen, setModalOpen] = useState(false);
    const [newTagName, setNewTagName] = useState('');

    // const addTag = () => {
    //   if (newTagName) {
    //     const newTag = { id: Date.now(), name: newTagName }; // Generate a unique ID
    //     setTags(currentTags => [...currentTags, newTag]);
    //     setNewTagName('');
    //     setModalOpen(false); // Close the modal
    //   }
    // };

    // const deleteTag = (id: any) => {
    //   setTags(tags.filter(tag => tag.id !== id));
    // };
    const [editTagId, setEditTagId] = useState(null);
    const [editTagName, setEditTagName] = useState('');

    const startEdit = (tag: any) => {
        setEditTagId(tag.id);
        setEditTagName(tag.name);
    };

    const stopEdit = () => {
        setEditTagId(null);
        setEditTagName('');
    };

    // const handleRename = (id: any) => {
    //   setTags(tags.map(tag => tag.id === id ? { ...tag, name: editTagName } : tag));
    //   stopEdit();
    // };

    // const handleKeyDown = (event: any, id: any) => {
    //   if (event.key === 'Enter') {
    //     handleRename(id);
    //   }
    // };
    const [notifications, setNotifications] = useState<boolean>(true);
    // const [ignoreCase, setIgnoreCase] = useState(false);
    // const [urlsToExclude, setUrlsToExclude] = useState('');
    // const [mustNotHave, setMustNotHave] = useState('');
    // const [mustHaveAll, setMustHaveAll] = useState('');
    // const [mustHaveAny, setMustHaveAny] = useState('');
    // const [mediaToExclude, setMediaToExclude] = useState('');
    // const [mediaToInclude, setMediaToInclude] = useState('');
    // const [robotOption, setRobotOption] = useState(true);

    const [useUrl, setUseUrl] = useState(true);
    const [useContent, setUseContent] = useState(false);
    const [discardFragments, setDiscardFragments] = useState(false);
    const [discardParameters, setDiscardParameters] = useState(false);
    const [parametersToUse, setParametersToUse] = useState('');
    const [parametersToDiscard, setParametersToDiscard] = useState('');
    // const [useHashFunction, setUseHashFunction] = useState(false);
    const [customHashFunction, setCustomHashFunction] = useState('');

    const [waitAfterLoad, setWaitAfterLoad] = useState(0);
    const [pollInterval, setPollInterval] = useState(500);
    const [newConnections, setNewConnections] = useState<any>(2);
    const [openConnections, setOpenConnections] = useState<any>(2);
    const [allowInteractive, setAllowInteractive] = useState(false);

    
    const [referrer, setReferrer] = useState('');
    const [restrictDomains, setRestrictDomains] = useState<any>([]);
    const [defaultPages, setDefaultPages] = useState<any>('index.htm');
    const [maxPages, setMaxPages] = useState<any>(1000);
    const [storePasses, setStorePasses] = useState(false);
    const [headlessMode, setHeadlessMode] = useState(false);

    const [scanRate, setScanRate] = useState<any>(0); // default to 1000ms
    const [scanDelay, setScanDelay] = useState<any>(0);


    const [expandedSections, setExpandedSections] = useState<any>([]);
    const handleToggleSection = (sectionKey: any) => {
        setExpandedSections((current: any) =>
            current.includes(sectionKey)
                ? current.filter((key: any) => key !== sectionKey)
                : [...current, sectionKey]
        );
    };

    const { CompanyUsers } = useAppSelector((state) => state.organization, shallowEqual);
    const messageStatus = ['Generating Sitemap', 'Scanning 25 pages of 100']

    const [opened, { open, close }] = useDisclosure(false);
    const [c] = useTranslation('siteList');
    const [ deletWebsite , setDeletWebsite ] = useState<any>("")
    const { showAlert } = useAlert()
    const [ javascriptPageUrl , setJavascriptPageUrl ] = useState("")


    useEffect(() => {
        const intervalId = setInterval(() => {
          const element = document.querySelector(`#MainAccordion-panel-${siteUUID}`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            clearInterval(intervalId); // Stop polling once the element is found
          }
        }, 100); // Poll every 100 milliseconds
    
        // Clean up the interval when the component is unmounted
        return () => clearInterval(intervalId);
      }, []);

      const [openedAccordion, setOpenedAccordion] = useState<any>(null);
      const [searchParams, setSearchParams] = useSearchParams();
      const sitedId = searchParams.get('sitedId');

      useEffect(() => {
        if(!sitedId){return;}
        setOpenedAccordion(`sitemap-${sitedId}`); 
        
      }, [sitedId])
      
      const handleAccordionChange = (value: any) => {
        
        setOpenedAccordion(value); // Tracks the current open accordion
      };
      const onWebsiteClick = (website:any)=>{
        if(isAccountPage){
            return;
        }
        navigate(`/dashboard/${website.site_id}/issues/automated-audit?siteUUID=${website?.id}&pageNumber=1&tId=${website?.tenantId}`)
        

      }
      const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
      const [settingsWebsiteModal, setSettingsWebsiteModal] = useState(false);
       const [currentUsers, setcurrentUsers] = useState([])
      useEffect(() => {
        if(!settingsWebsiteModal){
            return;
        }
        if(!companyId) return;

        if( CompanyUsers[companyId]){
            setcurrentUsers(CompanyUsers[companyId]);
            return;
        }

        dispatch(getOwnCompanyUsers({
            company_id:companyId,
        }));
   
      }, [settingsWebsiteModal])

      useEffect(() => {
        if(!companyId) return;

        if( CompanyUsers[companyId]){
            setcurrentUsers(CompanyUsers[companyId]);
            return;
        }

      }, [CompanyUsers])
      
      const [editPermission, setEditPermission] = useState<any>(null);
      const [webSitePermission, setWebSitePermission] = useState<any>(null);
      

    return (

        <>
        <Accordion
            chevronPosition="left"
            variant="separated"
            radius={'lg'}
            multiple={true}
            defaultValue={ siteUUID ? [siteUUID] : undefined }
            id="MainAccordion"
            chevron={<ChevronUp className={styles.circelBorder} />}

        >
            {

                        currentSiteLists?.length > 0 ?
                        currentSiteLists?.map((website: any, index: any) => {
                              

                        // handleInputChange(website?.id ?? "" , 'siteName', website?.name ?? "" )
                        // handleInputChange(website?.id ?? "" , 'auditStandard', website?.name ?? "" )

                        return (<Accordion.Item value={website?.id ?? ""} key={website?.id}>
                            {/* disabled={ website.status != 'done' } add this bellow */}
                            <Accordion.Control 
                            // onClick={()=>onWebsiteClick(website)}
                             >
                                <Group position="apart">
                                    <Tooltip multiline={true} label={wrapText(website.name)}>
                                        <Text weight={500}>{displayName(website.name)}</Text>
                                    </Tooltip>
                                    {/* {
                                website.status == 'done' ? null :
                                <Text style={{display:"flex"}}> {website?.message}<Loader h={'20px'} color="blue" /> </Text>
                            } */}
                            <Flex align={'center'}>
                            {/* {
                                isAccountPage ? 
                                    <Tooltip label="Website Settings" >
                                        <UnstyledButton style={{marginRight:'20px'}} className={styles['delete-btn']} onClick={(e)=>{
                                            setSelectedWebsite(website); 
                                            setSettingsWebsiteModal(true); 
                                            e.stopPropagation();
                                            }
                                            }
                                            aria-label='website Settings'
                                            >
                                            <Settings color="#A80000" size={44} /> 
                                        </UnstyledButton>
                                    </Tooltip>
                                :
                                null
                            } */}

                            {website.faviconUrl ? (
                            <img src={website.faviconUrl} alt={`${website.site_id} Favicon`} height={44} width={44}></img>
                            ) : (
                            <Link2 color="#5b5eff" size={44} />
                            )}                            
                            </Flex>
                        </Group>
                        <Text size="sm" color="dimmed">
                            URL: {website.url}
                        </Text>
                    </Accordion.Control>
                    {
                        // !isAccountPage ? null :
                    <Accordion.Panel>
                        <Card shadow="md" padding="xl" radius="lg" withBorder>
                            <div className={styles.settings}>
                                {/* <strong>{site.homepage} Settings</strong> */}

                                <div className={styles.sectionWrapper}>
                                    <Accordion
                                        chevronPosition="left"
                                        variant="separated"
                                        defaultValue={panel}
                                        classNames={{ chevron: styles.chevron }}
                                        radius={'lg'}
                                        multiple={false}
                                        onChange={handleAccordionChange}
                                    >
                                        {
                                            isAccountPage || website?.permissions?.includes('edit-site') ? 
                                        <Accordion.Item value={`sitemap-${website.site_id}`} key="Sitemap">
                                            <Accordion.Control>
                                                Sitemap
                                            </Accordion.Control>
                                            <Accordion.Panel>
                                                <div style={{ textAlign: "center" }}>
                                                    <SitemapTable siteID={website.site_id} openedAccordion = {openedAccordion} siteUUID={website?.id ?? ""} companyId={companyId}  />
                                                </div>
                                            </Accordion.Panel>
                                        </Accordion.Item>
                                        : null

                                        }

                                        {/* {
                                            isAccountPage || website?.permissions?.includes('edit-site') ? 
                                        <Accordion.Item value="manageAccess" key="manageAccess">
                                            <Accordion.Control>
                                                Manage Access
                                            </Accordion.Control>
                                            <Accordion.Panel>
                                                <div className={styles.detailsSection}>
                                                    <ManageAccessComponent website={website} />
                                                </div>
                                            </Accordion.Panel>
                                        </Accordion.Item>
                                        : null
                                        } */}

                                        {
                                            isAccountPage || website?.permissions?.includes('edit-site') ? 
                                        <Accordion.Item value={`settings-${website.site_id}`} key="Settings">
                                            <Accordion.Control>
                                                Settings
                                            </Accordion.Control>
                                            <Accordion.Panel>
                                            <div className={styles.detailsSection}>
                                                <SettingsPanelComponent website={website}  isAccountPage={isAccountPage} company_id={companyId} organization_id={organisationId}   />
                                            </div>
                                            </Accordion.Panel>
                                        </Accordion.Item>
                                        : null
                                        }

{
                                        isAccountPage || website?.permissions?.includes('edit-site') ? 
                                        <Accordion.Item value="Advanced Settings" key="Advanced Settings">
                                            <Accordion.Control>
                                                Advanced Settings
                                            </Accordion.Control>
                                            <Accordion.Panel>
                                                <div className={styles.detailsSection}>


                                                            <Accordion value={expandedSections}
                                                                onChange={setExpandedSections}
                                                                chevronPosition="left"
                                                                variant="separated"
                                                                // defaultValue="Settings"
                                                                classNames={{ chevron: styles.chevron }}
                                                                radius={'lg'}
                                                                multiple={false}
                                                            >
                                                                <Accordion.Item value="auditSettings">
                                                                    <Accordion.Control onClick={() => handleToggleSection('auditSettings')}>
                                                                        Configure Automated Audit Settings
                                                                    </Accordion.Control>
                                                                    <Accordion.Panel>
                                                                        <AdvancedSettingsComponent website={website} companyId={companyId} isAccountPage={isAccountPage}/>
                                                                    </Accordion.Panel>
                                                                </Accordion.Item>
                                                                <Accordion.Item value="cookies_settings_login">
                                                                    <Accordion.Control onClick={() => handleToggleSection('auditSettings')}>
                                                                        Javascript
                                                                    </Accordion.Control>
                                                                    <Accordion.Panel>
                                                                        <JavascriptAdvenceSettings website={website} />
                                                                    </Accordion.Panel>
                                                                </Accordion.Item>

                                                                <Accordion.Item value="api_itegration">
                                                                    <Accordion.Control onClick={() => handleToggleSection('auditSettings')}>
                                                                        Integration
                                                                    </Accordion.Control>
                                                                    <Accordion.Panel>
                                                                        <ApiIntegrationPreview website={website} />
                                                                    </Accordion.Panel>
                                                                </Accordion.Item>

                                                                {/* <Accordion.Item value="pageReadiness"> */}
                                                                {/* <Accordion.Control onClick={() => handleToggleSection('pageReadiness')}>Page Readiness Settings</Accordion.Control> */}
                                                                {/* <Accordion.Panel> */}
                                                                {/* <div style={{ paddingLeft: "20px" }}> */}
                                                                {/* <Tooltip label="Defines a delay before the system begins analysis to allow all scripts and content to fully load.">
                                                                        <div>
                                                                            <TextInput
                                                                                label="Wait time after page load (ms)"
                                                                                type="number"
                                                                                value={waitAfterLoad}
                                                                                onChange={(event) => setWaitAfterLoad(Number(event.currentTarget.value))}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Sets how frequently the system checks for active network connections to determine page readiness.">
                                                                        <div>
                                                                            <TextInput
                                                                                label="Polling interval used by all network checks (in milliseconds)"
                                                                                type="number"
                                                                                value={pollInterval}
                                                                                onChange={(event) => setPollInterval(Number(event.currentTarget.value))}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Specifies the maximum number of new network connections that can be initiated before considering the page as ready.">
                                                                        <div>
                                                                            <NumberInput
                                                                                label="Allowed number of new connections"
                                                                                value={newConnections}
                                                                                onChange={(newVal) => setNewConnections(newVal)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Sets the threshold of open connections that are considered acceptable for page readiness.">
                                                                        <div>
                                                                            <NumberInput
                                                                                label="Allowed number of open connections"
                                                                                value={openConnections}
                                                                                onChange={(newVal) => setOpenConnections(newVal)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip> */}

                                                                {/* <Tooltip label="When enabled, allows the system to treat the page as ready when the document state is 'interactive'. This is experimental and may lead to unpredictable results.">
                                                                        <div>
                                                                            <CheckboxMantin
                                                                                className={styles.notifyCheckbox}
                                                                                label="Allow interactive ready state (experimental)"
                                                                                checked={allowInteractive}
                                                                                onChecked={(event) => setAllowInteractive(event.currentTarget.checked)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip> */}
                                                                {/* </div> */}
                                                                {/* </Accordion.Panel> */}
                                                                {/* </Accordion.Item> */}

                                                                <Accordion.Item value={`sitemapSettings-${website?.id}`}>
                                                                    <Accordion.Control onClick={() => handleToggleSection('sitemapSettings')}>Sitemap Settings</Accordion.Control>
                                                                    <Accordion.Panel>
                                                                        <ManageSiteMapSettings website={website}  expandedSections={expandedSections}  />
                                                                    </Accordion.Panel>
                                                                </Accordion.Item>

                                                                <Accordion.Item value="uniquePageSettings">
                                                            <Accordion.Control onClick={() => handleToggleSection('uniquePageSettings')}>Unique Page Settings</Accordion.Control>
                                                            <Accordion.Panel>
                                                                <ManageUniquePages website={website} />
                                                            </Accordion.Panel>
                                                        </Accordion.Item>

                                                        {/*

                                                        <Accordion.Item value="pageAnalysisSettings">
                                                            <Accordion.Control onClick={() => handleToggleSection('pageAnalysisSettings')}> Page Analysis Settings</Accordion.Control>
                                                            <Accordion.Panel>
                                                                <div style={{ paddingLeft: "20px" }}>
                                                                    <Tooltip label="Enter Javascript to produce a unique title for the page">
                                                                        <div>
                                                                            <TextInput
                                                                                label="Javascript to produce unique title:"
                                                                                value={javascriptCode}
                                                                                onChange={(event) => setJavascriptCode(event.currentTarget.value)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Specify the referrer for the page analysis">
                                                                        <div>
                                                                            <TextInput
                                                                                label="Referrer:"
                                                                                value={referrer}
                                                                                onChange={(event) => setReferrer(event.currentTarget.value)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Restrict scanned domains to the specified list">
                                                                        <div>
                                                                            <Select
                                                                                label="Restrict scanned domains to:"
                                                                                data={['Domains defined in the domains list']}
                                                                                value={restrictDomains}
                                                                                onChange={setRestrictDomains}
                                                                                placeholder="Select domain restrictions"
                                                                                multiple
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Specify default pages for scanning">
                                                                        <div>
                                                                            <Select
                                                                                label="Default Pages:"
                                                                                data={['index.htm', 'index.html']}
                                                                                value={defaultPages}
                                                                                onChange={setDefaultPages}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Set the maximum number of pages to be analyzed">
                                                                        <div>
                                                                            <NumberInput
                                                                                label="Maximum number of pages:"
                                                                                value={maxPages}
                                                                                onChange={(newVal) => setMaxPages(newVal)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Choose whether to store passes and inapplicable items">
                                                                        <div>
                                                                            <CheckboxMantin
                                                                                className={styles.notifyCheckbox}
                                                                                label="Store Passes and Inapplicables:"
                                                                                checked={storePasses}
                                                                                onChecked={(event) => setStorePasses(event.currentTarget.checked)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Tooltip label="Enable or disable running the browser in 'Headless' mode">
                                                                        <div>
                                                                            <CheckboxMantin
                                                                                className={styles.notifyCheckbox}
                                                                                label="Run browser in 'Headless' mode:"
                                                                                checked={headlessMode}
                                                                                onChecked={(event) => setHeadlessMode(event.currentTarget.checked)}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>
                                                                </div>
                                                            </Accordion.Panel>
                                                        </Accordion.Item> */}
                                                            </Accordion>


                                                            {/* <Button className={styles.saveButton}>
                                                        Save Advanced Settings
                                                    </Button> */}
                                                        </div>
                                                    </Accordion.Panel>
                                        </Accordion.Item>
                                        : null
                                        }

                                        {
                                        isAccountPage || website?.permissions?.includes('delete-site') ? 
                                        <Flex justify={"end"} align={"center"}>
                                            <UnstyledButton pl={"md"} onClick={() => {
                                                if (!website?.site_id) return;
                                                setDeletWebsite(website?.id)
                                                open()
                                            }} aria-label={c('removeSite')} className={styles['delete-btn']}>
                                                {c('deleteSite')}
                                                <Trash2 color="#A80000" />
                                            </UnstyledButton>
                                        </Flex> :
                                        null
                                        }
                                            </Accordion>
                                        </div>
                                    </div>


                                    {/* <Group position="apart" mb="md">
                                <Title order={3}>{website.name}</Title>
                                <ActionIcon variant="outline" size="xl">
                                    <img src={website.icon} alt={website.name} width="30" height="30" style={{ borderRadius: '50%' }} />
                                </ActionIcon>
                            </Group>

                            <Divider my="sm" />

                            <TextInput
                                placeholder="Enter website name"
                                label="Name"
                                size="md"
                                value={website.name}
                                icon={<Menu size={18} />}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => handleUpdate(index, 'name', e.target.value)}
                            />

                            <Space h="md" />

                            <TextInput
                                placeholder="Enter website URL"
                                label="URL"
                                size="md"
                                value={website.url}
                                icon={<Link size={18} />}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => handleUpdate(index, 'url', e.target.value)}
                            />

                            <Space h="md" />

                            <TextInput
                                placeholder="Enter icon URL"
                                label="Icon URL"
                                size="md"
                                value={website.icon}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => handleUpdate(index, 'icon', e.target.value)}
                            />

                            <Space h="lg" />

                            <Button fullWidth>
                                Save Changes
                            </Button> */}
                                </Card>
                            </Accordion.Panel>
                    }
                        
                        </Accordion.Item>)

                    }) : loadingCompanyWebsites || loadigSitesUser ? 
                    <Flex justify={"center"} align={"center"} mt={'15px'}>
                          <AutomatedAuditLoader />
                    </Flex>
                    
                    :  <Flex justify={"center"} align={"center"}>
                            <p>You Have No Site Available</p>
                    </Flex>
            }
        </Accordion>

        <Modal opened={opened} close={close} zIndex={1000} withCloseButton={false} size={450} padding={0}>
        <Group align={'center'} position={'center'} p={28}>
          <Title order={3}>{c('removeSite')}</Title>
          <Text align={'center'}>
            {c('modalFirstRow')}
            <br />
            {c('modalSecondRow')}
          </Text>
        </Group>
        <div className={classNames(styles['btn-group'])}>
          <UnstyledButton onClick={close} className={classNames(styles['action-btn'])}>
            {c('modalCancel')}
          </UnstyledButton>
          <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
          <UnstyledButton
            onClick={() => {
                if(!companyId){
                    return;
                }
              dispatch(removeSiteList({siteUUID:deletWebsite,companyId:companyId,isAccountPage , 
                submitCallback: () => {
                    showAlert({
                        id: 'settings-update',
                        title: `Delete Website`,
                        message: `Website has been Delete Successfully.`,
                        variant: 'success',
                        autoClose: 2000
                    });
                    if ( selectedSiteData?.value == deletWebsite ) {
                        dispatch(selectedSite({ selectedSiteData: null }));
                        localStorage.removeItem('selectedSite')
                    }
                    dispatch(currentAction())
                    },
                    errorCallback: (error: string) => {
                    showAlert({
                        id: error,
                        title: `Delete Website`,
                        message: error,
                        variant: 'error',
                        autoClose: 2000
                    });
                    }
            
            }));
              close()
            }}
            className={classNames(styles['action-btn'])}>
            {t('modalDelete')}
          </UnstyledButton>
        </div>
      </Modal>





      <Modal opened={settingsWebsiteModal} close={()=>{setSettingsWebsiteModal(false)}} zIndex={1000} withCloseButton={false} size={800} padding={20}>
                <Group align={'center'} position={'center'} p={28}>
                    <Title order={3}>{selectedWebsite?.site_name} Settings </Title>
                </Group>
                
                <Tabs defaultValue="users">
                    <Tabs.List>
                        <Tabs.Tab value="users" icon={<Users size="0.8rem" />}>Users</Tabs.Tab>
                    </Tabs.List>


                    <Tabs.Panel value="users" pt="xs">
                    <Flex>

                    <Navbar height={600} p="xs" width={{ base: 300 }}>
                        <Navbar.Section mt="xs"><Users size="0.8rem" /> Users</Navbar.Section>

                        <Navbar.Section grow component={ScrollArea} mx="-xs" px="xs">
                        {
                                currentUsers?.map((user:any, index:number) => (
                                    <Flex 
                                    pl={"lg"} 
                                    w={'100%'}
                                    aria-label={user.user_email} 
                                    className={styles['categBtn']} 
                                    >
                                        <Text
                                            w={'100%'}
                                        >
                                            {user.user_email}

                                        </Text>
                                        <div style={{display:'flex'}}>
                                                <UnstyledButton  
                                                    style={{marginRight:'15px'}}
                                                    onClick={() => { 
                                                        setEditPermission({tenant_id: user.user_tenant_id ,company_id:user.company_id});
                                                    }} 
                                                    >
                                                        <Edit size={20}/>
                                                </UnstyledButton>
                                                
                                                {/* <UnstyledButton  
                                                    onClick={() => { 

                                                        if (window.confirm("Are you sure you want to remove this user from the company?")) {
                                                            dispatch(removeUserFromCompany({tenant_id: user.user_tenant_id, company_id: user.company_id}));
                                                        }
                                                        // dispatch(removeUserFromCompany({tenant_id: user.user_tenant_id ,company_id:user.company_id})) ;
                                                    }} 
                                                    >
                                                        <Trash2 size={20}/>
                                                </UnstyledButton> */}

                                        </div>

                                    </Flex>
                                    ))
                        }
                        </Navbar.Section>
                        </Navbar>
                            {
                                editPermission?.tenant_id  ?
                                <div>
                                <Navbar height={200} p="xs" width={{ base: 300 }}>
                                        <>
                                            <Title order={3}>Assign Website Permission</Title>
                                            {/* <Select
                                                label="Website Permissions"
                                                placeholder="Website Permissions"
                                                data={[{label:'View Site',value:"view-site"}, {label:"Edit Site",value:"edit-site"}, {label:"Delete Site",value:"delete-site"}]}
                                                aria-label="Website Permission"
                                                className={styles.settingSelect}
                                                onChange={(e) => { e && setWebSitePermission([e]) }}
                                                defaultValue={"get-site-data"}
                                            /> */}


                                            <MultiSelect
                                                data={[{label:'View Site',value:"view-site"}, {label:"Edit Site",value:"edit-site"}, {label:"Delete Site",value:"delete-site"}]}
                                                // data={tags[org.organization]?.tags || []} // Show all tags at the organization level
                                                placeholder="Website Permissions"
                                                aria-label="Website Permission"
                                                value={webSitePermission}
                                                onChange={setWebSitePermission}
                                                creatable
                                                searchable
                                                getCreateLabel={(query) => `+ Create "${query}"`}
                                                onCreate={(query) => {
                                                const newTag = query.trim();
                                                setWebSitePermission((current:any) => [...current, newTag]);
                                                return newTag; // Return the new tag string
                                                }}
                                                className={styles.settingSelect}
                                                // style={{ marginTop: '10px', marginBottom: '10px' }}
                                                            />
                                            <UnstyledButton 
                                                className={styles['saveCategBtn']} 
                                                pl={"sm"} w={'100%'}  
                                                onClick={() => {
                                                    if(!webSitePermission){alert('you should set a permission'); return;}; 
                                                        dispatch(assignWebSitePermission({tenant_id:editPermission.tenant_id,company_id:editPermission.company_id,permission:webSitePermission,siteUUID:selectedWebsite.id}));
                                                        setEditPermission(null); 
                                                    }} 
                                                aria-label='Assign a Website Permission' 
                                                style={{paddingBottom:'15px'}}
                                            >
                                                Assign Permission
                                            </UnstyledButton>
                                        </>
                                </Navbar> 
                                </div>
                                :
                                null
                            }

                    </Flex>                        
                    </Tabs.Panel>
                </Tabs>

            </Modal>

        </>
    );
}

function JavascriptAdvenceSettings({ website }: { website: ISiteListData }) {

    const { settingsLoading } = useAppSelector((state) => state.automatedReports, shallowEqual);
    const { showAlert } = useAlert();
    const dispatch = useAppDispatch();

    const form = useForm({
        initialValues: {
            url: website?.jsCode?.url ??  website?.url ?? "",
            code: website?.jsCode?.code ?? ""
        },
        transformValues: (values) => {
            let newUrl;
            const urlPattern = /^((http|https):\/\/)/;

            if (!urlPattern.test(values.url)) {
                newUrl = 'https://' + values.url;
            }
            return {
                url: newUrl || values.url,
                code: values.code,
            };
        },
        validate: {
            url: (value) => {
                 
                if (!checkValidHttps(value)) {
                    setNeedFocus(true);
                    return 'Please enter a valid HTTPS URL';
                } else {
                    if (website?.url && !value.startsWith(website?.url)) {
                        return 'The URL does not match the original website';
                    }
                }
                return null;
            },
            code: (value) => {
                if (!value) {
                    setNeedFocus(true)
                    return 'Code Must Not be empty'
                }
                return null;
            }
        },

    });

    const { setNeedFocus } = useFormFocus({ formErrors: form.errors });
    const updateSettings = (url: string, code: string): void => {
        const data = {
            url:website?.url,
            frequency: website?.frequency ?? 'None',
            auditSpeed: website?.auditSpeed ?? 'normal',
            notifications: website?.notifications,
            name: website?.name,
            jsCode: {
                url,
                code
            }
        };
        dispatch(updateReportSettings({ data, id: website?.id ,
            successMessage: () => {
                showAlert({
                    id: 'settings-update',
                    title: `${website?.name} Settings updated`,
                    message: `Settings Has Been Updated Successfully.`,
                    variant: 'success',
                    autoClose: 2000
                });
                },
                errorCallback: (error: string) => {
                showAlert({
                    id: error,
                    title: `${website?.name} Settings Update Failed`,
                    message: error,
                    variant: 'error',
                    autoClose: 2000
                });
                }
        
        }));
    }
    return (
        <>
            <Space h={"sm"} />
            <form
                onSubmit={form.onSubmit((values) => {
                    updateSettings(values.url, values.code)
                })}>
                <TextInput
                    label="Page Url To Run JavaScript Code"
                    type="text"
                    placeholder='https://vially.io/insight/auth/login'
                    {...form.getInputProps('url')}
                />
                <Space h={"sm"} />
                <Textarea
                    minRows={6}
                    autosize={true}
                    {...form.getInputProps('code')}
                    placeholder='Javascript Snippet Here ...'
                />
                <Space h={"sm"} />
                <Flex justify={"end"}>
                    <Button loading={settingsLoading} type='submit'>Submit</Button>
                </Flex>
            </form>
        </>
    )
}

function SettingsPanelComponent({ website , isAccountPage , company_id , organization_id  }: { website: ISiteListData, isAccountPage : boolean ,  company_id? : string , organization_id? : string }) {
    const dispatch = useAppDispatch();
    const {showAlert} = useAlert();
    const [siteName, setSiteName] = useState<string>(website?.name || "")    
    const [notifications, setNotifications] = useState<boolean>(website?.notifications ?? false)
    const { settingsLoading } = useAppSelector((state) => state.automatedReports, shallowEqual);
    const [auditStandard, setAuditStandard] = useState<any>(website?.auditStandard ?? "WCAG 2.1AA")
    const [siteUrl, setSiteUrl] = useState<any>(website?.url ?? "")
    // settings section
    const updateSettings = (): void => {
        const data = {
            // engine_id: website?.engine_id,
            url:siteUrl,
            frequency: website?.frequency ?? 'None',
            auditSpeed: website?.auditSpeed ?? 'normal',
            notifications,
            name: siteName,
            auditStandard,
            site_UID: website.id
        }; 
        const response  = dispatch(updateReportSettings({ data, id: website?.id ,
        
            successMessage: () => {
                dispatch(fetchSiteList({currentCompanyId:company_id,isAccountPage , 
                    submitCallback : (UpdatedWebsites:any) => {
                        const selectedOne = UpdatedWebsites.find((site:any) => site.id == website?.id )
                        if ( selectedOne ) {
                            localStorage.setItem('selectedSite', JSON.stringify(selectedOne));
                            dispatch(selectedSite({ selectedSiteData: selectedOne }));
                        }
                    }                
                }));
                showAlert({
                    id: 'settings-update',
                    title: `${website?.name} Settings updated`,
                    message: `Settings Has Been Updated Successfully.`,
                    variant: 'success',
                    autoClose: 2000
                });
                },
                errorCallback: (error: string) => {
                showAlert({
                    id: error,
                    title: `${website?.name} Settings Update Failed`,
                    message: error,
                    variant: 'error',
                    autoClose: 2000
                });
                }
        }));
    };
    return (

        <div>
            <TextInput
                withAsterisk={true}
                label="Site Name"
                placeholder="Edit site name"
                value={siteName}
                onChange={(e) =>
                    setSiteName(e.target.value)
                }
                className={styles.settingSelect}
            />
            <TextInput
                error={!checkValidHttps(siteUrl)}
                withAsterisk={true}
                label="Site URL"
                placeholder="Edit site URL"
                value={siteUrl}
                onChange={(e) =>
                    setSiteUrl(e.target.value)
                }
                className={styles.settingSelect}
            />

            <Select
                label="Audit Standard"
                value={auditStandard}
                data={[
                    // { label: "WCAG 2.0", value: "WCAG 2.0" },
                    { label: "WCAG 2.1A", value: "WCAG 2.1A" },
                    { label: "WCAG 2.1AA", value: "WCAG 2.1AA" },
                    { label: "WCAG 2.1AAA", value: "WCAG 2.1AAA" },
                    { label: "ADA 2.1 AA", value: "ADA 2.1 AA" },
                    // { label: "WCAG 2.2AA", value: "WCAG 2.2AA" },
                    // { label: "WCAG 2.2AAA", value: "WCAG 2.2AAA" },
                ]}
                aria-label="Audit Standard, open the dropdown field to select from the WCAG audit standard options. Press the spacebar to open the dropdown on your keyboard and use the arrow keys to navigate"
                placeholder="Select Audit Standard"
                style={{ marginTop: "10px", marginBottom: "10px" }}
                onChange={(e) => setAuditStandard(e) }

            />

            {/* <ButtonMantin
          variant="outline"
          className={styles.settingButton}>
          Rescan {website.name}
      </ButtonMantin> */}
            {/* <Button variant="outline" className={styles.settingButton}>
  Manage Sitemap
  </Button> */}
            {/* <MultiSelect
  data={tags}
  placeholder="Select tags"
  label="Your favorite frameworks"
  searchable
  creatable
  getCreateLabel={(query) => `+ Add ${query}`}
  onCreate={(query) => setTags((current) => [...current, query])}
  value={tags}
  onChange={setTags}
  /> */}

            <Box sx={{ padding: "20px 0", backgroundColor: "#fff" }}>
                {/* <Flex justify={"space-between"} align={"center"}> */}
                {/* <Text size="md" weight={400}> Labels</Text> */}
                {/* <ButtonMantin
                  variant="light"
                  style={{ margin: '10px 0' }} onClick={() => setModalOpen(true)}>Add new label</ButtonMantin> */}
                {/* </Flex> */}

                {/* <MultiSelect
              data={tags} // Show all tags at the organization level
              placeholder="Select or add tags"
              value={['Sport', 'Event']}
              onChange={setSelectedTags}
              creatable
              searchable
              getCreateLabel={(query) => `+ Create "${query}"`}
              onCreate={(query) => {
                  const newTag = query.trim();
                  setSelectedTags((current) => [...current, newTag]);
                  return newTag; // Return the new tag string
              }}
              style={{ marginTop: '10px', marginBottom: '10px' }}
          /> */}
                {/* {tags.map(tag => (
              <Group key={tag.id} position="apart" style={{ margin: '10px 0' }}>
                  {editTagId === tag.id ? (
                      <TextInput
                          autoFocus
                          value={editTagName}
                          onChange={(event) => setEditTagName(event.currentTarget.value)}
                          onKeyDown={(event) => handleKeyDown(event, tag.id)}
                          onBlur={() => stopEdit()} // Optional: stop editing on blur
                      />
                  ) : (
                      <Text>{tag.name}</Text>
                  )}
                  {/* <Menu withinPortal position="bottom-end"> */}
                {/* <Menu.Target>
                          <Button>⋮</Button>
                      </Menu.Target> */}
                {/* <Menu.Dropdown>
                          <Menu.Item onClick={() => startEdit(tag)}>Rename</Menu.Item>
                          {/* <Menu.Item onClick={() => console.log('View users with tag')}>View users with tag</Menu.Item> */}
                {/* <Menu.Item onClick={() => console.log('View tag usage')}>View tag usage</Menu.Item> */}
                {/* <Menu.Item color="red" onClick={() => deleteTag(tag.id)}>Delete</Menu.Item> */}
                {/* </Menu.Dropdown>  */}
                {/* </Menu> */}
                {/* <ButtonMantin onClick={deleteTag} style={{ marginTop: 10 }}>
                 Delete
              </ButtonMantin>
              </Group> */}
                {/* ))} */}
                {/*
          <Modal
              opened={isModalOpen}
              onClose={() => setModalOpen(false)}
              title="Add a New Label"
              zIndex={1000}
          >
              {/* <Group align={'center'} position={'center'} p={28}> */}
                {/* <TextInput
                  label="Label Name"
                  placeholder="Enter a new Label name"
                  value={newTagName}
                  onChange={(event) => setNewTagName(event.currentTarget.value)}
                  onKeyPress={(event) => {
                      if (event.key === 'Enter') {
                          addTag();
                      }
                  }}
              />
              <ButtonMantin onClick={addTag} style={{ marginTop: 10 }}>
                  Add Label
              </ButtonMantin> */}
                {/* </Group> */}
                {/* </Modal>  */}
            </Box>
            <Tooltip label="send email notification when audit start or complete">
                <div style={{ marginLeft: "auto" }}>
                    <CheckboxMantin
                        className={styles.notifyCheckbox}
                        label="Send Email Notification When Audit Start or Complete"
                        onChecked={(e) =>
                            setNotifications(e.target.checked)
                        }
                        checked={notifications}
                    />
                </div>
            </Tooltip>
            {/* <FileInput
          className={styles.settingFileInput}
          label="Upload new Website Icon"
          aria-label="Upload new Website Icon"
          placeholder="Website Icon"
      /> */}
            <Button disabled={!siteName || !checkValidHttps(siteUrl)} loading={settingsLoading} className={styles.saveButton} onClick={() => updateSettings()}>Save Settings</Button>

        </div>
    );
};

function AdvancedSettingsComponent({ website,companyId, isAccountPage }: { website: ISiteListData,companyId:String|undefined, isAccountPage?:any }) {

    const dispatch = useAppDispatch();
    const { settingsLoading, reportSettings , error } = useAppSelector((state) => state.automatedReports, shallowEqual);
    const {showAlert} = useAlert();
    const [deviceType, setDeviceType] = useState(website?.deviceName ?? 'Windows 10 Laptop 15-inch')
    const [frequency, setFrequency] = useState(website?.frequency ?? 'Quarterly')
    const [auditSpeed, setAuditSpeed] = useState(website?.auditSpeed ?? 'normal')
    const [concurrentAuditLimit, setConcurrentAuditLimit] = useState(website?.workersNbr ?? 4);

     
    const updateSettings = (): void => {
        const data = {
            url:website?.url,
            name: website?.name,
            // engine_id: website?.engine_id,
            frequency,
            auditSpeed,
            deviceName: deviceType,
            notifications: website.notifications,
            site_UID: website.id,
            workersNbr:concurrentAuditLimit
        };        
        dispatch(updateReportSettings({ data, id: website?.id  , 
            successMessage: () => {
                dispatch(fetchSiteList({currentCompanyId:companyId,isAccountPage}));
                showAlert({
                    id: 'settings-update',
                    title: `${website?.name} Advance Settings updated`,
                    message: `Settings Has Been Updated Successfully.`,
                    variant: 'success',
                    autoClose: 2000
                });
                },
                errorCallback: (error: string) => {
                showAlert({
                    id: error,
                    title: `${website?.name} Settings Update Failed`,
                    message: error,
                    variant: 'error',
                    autoClose: 2000
                });
                }
        
        }));
    }
    return <div style={{ paddingLeft: "20px" }}>
        <Tooltip label="Select the type of device for the audit">
            <div>
                <Select
                    label="Device Type"
                    placeholder="Select Device"
                    data={[
                        "iPhone 12",
                        "iPhone 11",
                        "Samsung Galaxy S10",
                        "Google Pixel 5",
                        "MacBook Pro 15-inch",
                        "MacBook Air 13-inch",
                        "Windows 10 Laptop 15-inch",
                        "Windows 10 Laptop 13-inch",
                    ]}
                    aria-label="Device Type, open the dropdown field to select from the Devices Type options. Press the spacebar to open the dropdown on your keyboard and use the arrow keys to navigate"
                    className={styles.settingSelect}
                    onChange={(e) => { e && setDeviceType(e) }}
                    defaultValue={deviceType}
                />
            </div>
        </Tooltip>
        <Tooltip label="Choose how frequently automated audits should be performed">
            <div>
                <Select
                    label="Automated Audit Frequency"
                    defaultValue={'none'}
                    placeholder="Choose Frequency"
                    data={['None', 'Monthly', 'Quarterly']}
                    className={styles.settingSelect}
                    value={frequency}
                    onChange={(e) => e && setFrequency(e)}
                    aria-label="Automated Audit Frequency, open the dropdown field to select from the Frequency options. Press the spacebar to open the dropdown on your keyboard and use the arrow keys to navigate"
                />
            </div>
        </Tooltip>

        <Tooltip label="Select the audit type to be conducted (Abbreviated is a quick audit that stops scanning for issues after finding the first criteria and moves onto the next)">
            <div>
                <Select
                    label="Audit Type"
                    placeholder="Choose Audit Type"
                    data={[{ label: 'Standard', value: 'normal' }, { label: 'Abbreviated', value: 'high' }]}
                    defaultValue={auditSpeed}
                    className={styles.settingSelect}
                    onChange={(e) => e && setAuditSpeed(e)}
                    aria-label="Audit Type, open the dropdown field to select from the Audit Type options. Press the spacebar to open the dropdown on your keyboard and use the arrow keys to navigate"
                />
            </div>
        </Tooltip>

        <Tooltip label="Set the number of concurrent workers used to audit pages. You can reduce this value to limit parallel audits. The maximum allowed is 4.">
            <div>
                <NumberInput
                    className={styles.settingSelect}
                    label="Concurrent Audit Workers"
                    description="Number of concurrent workers to audit sites (maximum is 4)."
                    value={concurrentAuditLimit}
                    onChange={(val:any) => setConcurrentAuditLimit(val)}
                    min={1}
                    max={4}
                />
            </div>
        </Tooltip>



        {/* <Tooltip label="Defines the frequency at which the system performs scans (in milliseconds)">
        <div>
            <NumberInput
                label="Scan Rate (ms):"
                description="Defines the frequency at which the system performs scans (in milliseconds)."
                value={scanRate}
                onChange={(NewVal) => setScanRate(NewVal)}
                min={100}
            />
        </div>
    </Tooltip> */}
        <Button loading={settingsLoading} onClick={() => { updateSettings() }}>Save Advanced Settings</Button>
    </div>
}
type organizationSelect = {
    label: string;
    value: string;
}
function ManageAccessComponent({ website }: { website: ISiteListData }) {
    const dispatch = useAppDispatch();
    const [c] = useTranslation('account');
    const { showAlert } = useAlert();

    // const { settingsLoading, reportSettings } = useAppSelector((state) => state.automatedReports, shallowEqual);
    const { company_id, tenantId } = useAppSelector((state) => state.user.data, shallowEqual);

    const [selectedOrganisation, setSelectedOrganization] = useState<organizationSelect | null>(null);
    const [errorOrganisation, setErrorOrganisation] = useState<String | null>(null)

    const { loadingUserOrganizations,
        ClientOrganizations,
        OrgsJoined,
        loadingOrgsJoined,
        loadingClientOrganizations,
        grantAccess,
        removeAccessToOrganizationState,
        removeAccessToOrganizationError,
    } = useAppSelector((state) => state.organization, shallowEqual);

    // useEffect(() => {
    //     if (!tenantId) {
    //         return;
    //     }
    //     // dispatch(getJoinedOrganization({ company_id: user.company_id }));
    //     dispatch(getClientOrganizations({ tenantId }));
    //     ;
    // }, []);

    const [dataOptions, setDataOptions] = useState<any>([]);
    useEffect(() => {
        // organizations
        let clientOrgs: any[] = [];
        let joinedOrgs: any[] = [];
        if (ClientOrganizations && ClientOrganizations.length > 0) {
            clientOrgs = ClientOrganizations && ClientOrganizations?.map((org: any) => {
                return {
                    label: org?.name || org?.organisation_name,
                    value: org?.id,
                };
            })
        }


        if (OrgsJoined?.length > 0 && !OrgsJoined?.message) {

            joinedOrgs = OrgsJoined && OrgsJoined?.map((org: any) => {
                return {
                    label: org?.organization_name,
                    value: org?.organization_id,
                };
            })
        }
        const data = [...clientOrgs, ...joinedOrgs]
        setDataOptions(data)
        data.length && setSelectedOrganization(data[0])
    }, [ClientOrganizations, OrgsJoined, loadingClientOrganizations, loadingOrgsJoined]);


    function grantAccessFunction() {
        dispatch(grantAccessToOrganization({
            organization_id: selectedOrganisation?.value,
            siteUUID: website?.id,
            company_id
        }));



    }
    const removeAccess = () => {
        const ids = [website?.id]
        dispatch(removeAccessToOrganization({ organizationId: selectedOrganisation?.value, tenantId, siteToremove: ids }));
        dispatch(UpdateremoveAccessToOrganizationSaga());
    };

    useEffect( () => {

        
        
        if ( grantAccess ) {
            showAlert({
                id: grantAccess,
                title: grantAccess,
                variant: 'success',
                autoClose: 3000,
            });
            dispatch(updategrantAccessToOrganizationSuccess());
            return
        }

        // if ( removeAccessState  ) {
        //     // console.log(removeAccessState);
        // }

        if ( removeAccessToOrganizationError  ) {

            // showAlert({
            //     id: removeAccessToOrganizationError,
            //     title: removeAccessToOrganizationError,
            //     variant: 'error'
            // });

            dispatch(UpdateremoveAccessToOrganizationSaga());
            return
        }
        if ( removeAccessToOrganizationState ){

            showAlert({
                id: removeAccessToOrganizationState,
                title: removeAccessToOrganizationState,
                variant: 'success',
                autoClose: 3000,
            });

            dispatch(_UpdateremoveAccessToOrganizationSagaSucess());
            return


        }
    } , [grantAccess  , removeAccessToOrganizationError , removeAccessToOrganizationState])

    return (
        <div style={{ paddingLeft: '1rem'}}>
            <Select
                className={styles['select-organization']}
                error={errorOrganisation ? c('notificationTab.InviteCompany.error') : null}
                label={String(c('notificationTab.inviteCompany.select'))}
                variant="primary"
                value={selectedOrganisation ? selectedOrganisation.value : null}
                data={dataOptions}
                onChange={(e) => {
                    if (e) {
                        const company = dataOptions.find((o: any) => o.value === e)
                        if (company) {
                            setSelectedOrganization(company)
                            setErrorOrganisation(null)
                        }
                    }
                }}
            />
            <Space h={"sm"} />
            <Flex align={"center"} gap={"sm"}>
                <Button onClick={() => grantAccessFunction()}>Grant Access</Button>
                <Button color='dark-green' onClick={() => removeAccess()}>Remove Access</Button>
            </Flex>
        </div>

    );
};

function ManageSiteMapSettings({ website ,expandedSections}: { website: ISiteListData,expandedSections:string }) {
    const { showAlert } = useAlert();
    const { tenantId } = useAppSelector((state) => state.user.data, shallowEqual);
    const [ loading , setIsloading ] = useState(false)
    async function handleSiteMapChange(values:any) { 
        try {
            const result = await apiInstance.post("/reporttool/organisationlevel/sitemap/settings/update" , { 
                tenantId,
                siteUUID : website?.id,
                // excludedUrls : values.excludedUrls,
                // mustHaveAny : values.mustHaveAny,
                // mustHaveAll : values.mustHaveAll,
                // mustNotHave : values.mustNotHave,
                // mediaTypeExcluded : values?.mediaTypeExcluded?.split(',').join(', ') ?? [],
                mediaTypeIncluded : values?.mediaTypeIncluded.join(',')
            })
            if (result?.status == 200 || result?.status == 201 ){
                showAlert({
                    id: result?.data?.data?.siteUUID,
                    message : result?.data?.message,
                    title: "Site Map Settings Updated",
                    variant: "success",
                    autoClose: 3000,
                });
                return
            }

            showAlert({
                id: 'error_saving',
                title: "Site Map Settings Updated",
                message: "Unable To Update Site Map Settings",
                variant: "error",
                autoClose: 3000,
            });


        }catch (e:any) {
            showAlert({
                id: 'error_saving',
                title: "Site Map Settings Updated",
                message:  e?.response?.data?.message  ??  "Unable To Update Site Map Settings",
                variant: "error",
                autoClose: 3000,
            });

        }
    }

    const initialValues: Record<string, any> = {
        // excludedUrls : "",
        // mustHaveAny : "",
        // mustHaveAll : "",
        // mustNotHave: "",
        // mediaTypeExcluded : [],
        mediaTypeIncluded :  [],
        // ignoreRobotTxt : "",
        // ignoreCaseUrls : ""
    };
    const form = useForm({
        initialValues: initialValues,
        // all the field are optional.
        validate: {
            // excludedUrls: (value) => {
            //     if (!value) {
            //         setNeedFocus(true)
            //         return "URLs to exclude cannot be empty";
            //     }
            //     return null;
            // },
            // mustHaveAny: (value) => {
            //     if (!value) {
            //         setNeedFocus(true)
            //         return "Elements to include must not be empty";
            //     }
            //     return null;
            // },
            // mustHaveAll: (value) => {
            //     if (!value) {
            //         setNeedFocus(true)
            //         return "Elements to include must not be empty";
            //     }
            //     return null;
            // },
            // mustNotHave: (value) => {
            //     if (!value) {
            //         setNeedFocus(true)
            //         return "Elements to exclude must not be empty";
            //     }
            //     return null;
            // },
        //     mediaTypeExcluded: (value) => {
        //         if (!value) {
        //             setNeedFocus(true)
        //             return "Media Type Excluded must not be empty";
        //         }
        //         return null;
        //     },
            mediaTypeIncluded: (value) => {
                if ((Array.isArray(value) && value?.length == 0) || !value) {
                    setNeedFocus(true)
                    return "Media Type Included to exclude must not be empty";
                }
                return null;
            },
        }
    });
    const { setNeedFocus } = useFormFocus({ formErrors: form.errors });

    
    async function getSettingsPayload(id:string) {
         
        try {
            setIsloading(true)
            const result = await apiInstance.post("/reporttool/organisationlevel/sitemap/settings/get", {
                siteUUID : id,
                tenantId
            }) 
            
            if ( result?.data && result?.status == 200 ) {
                // form.setFieldValue("excludedUrls" , result?.data?.excludedUrls  )
                // form.setFieldValue("mustHaveAny" , result?.data?.mustHaveAny )
                // form.setFieldValue("mustHaveAll" ,  result?.data?.mustHaveAll )
                // form.setFieldValue("mustNotHave" ,  result?.data?.mustNotHave )
                // form.setFieldValue("mediaTypeExcluded" , result?.data?.mediaTypeExcluded )
                form.setFieldValue("mediaTypeIncluded" ,  result.data.mediaTypeIncluded.split(','))
            }
           
        
        }catch(e:any) {
            console.log(e);
        }finally {
            setIsloading(false)
        }
    }

    useEffect( () => {

        if ( expandedSections != `sitemapSettings-${website?.id}`) {
            return
        }
        
        if ( website?.id  ) {
            getSettingsPayload(website?.id)
        }
    },[website?.id , expandedSections])


    return (
        <form
            aria-disabled={loading}
            onSubmit={form.onSubmit((values) => {
                handleSiteMapChange(values)
            })}
        style={{ paddingLeft: "20px" }}>
        {/* <Tooltip label="Specify URLs to exclude from the sitemap">
            <div>
                <Textarea
                    placeholder={'URLs to exclude'}
                    label="URLs to exclude:"
                    {...form.getInputProps('excludedUrls')}
                />
            </div>
        </Tooltip>
        <Tooltip label="Specify elements that must not be present">
            <div>
                <Textarea
                    placeholder={'Must not have'}
                    label="Must not have:"
                    {...form.getInputProps('mustNotHave')}
                />
            </div>
        </Tooltip>
        <Tooltip label="Specify elements that must be present">
            <div>
                <Textarea
                    placeholder={'Must have all'}
                    label="Must have all:"
                    {...form.getInputProps('mustHaveAll')}

                />
            </div>
        </Tooltip>
        <Tooltip label="Specify elements that may be present">
            <div>
                <Textarea
                    placeholder={'Must have any'}
                    label="Must have any:"
                    {...form.getInputProps('mustHaveAny')}
                />
            </div>
        </Tooltip> */}
        <Space h={"sm"} />
        {/* <Checkbox.Group
            label="Media Types To Exclude"
            {...form.getInputProps('mediaTypeExcluded')}
            >
            <Group mt="xs" >
                <Checkbox value="JPG" label="JPG" />
                <Checkbox value="PNG" label="PNG" />
            </Group>
        </Checkbox.Group> */}
        <Checkbox.Group
            label="Media Type To Audit"
            {...form.getInputProps('mediaTypeIncluded')} 
            >
            {/* <Group mt="xs"  > */}
                <Tooltip label="Audio File (e.g., MP3)">
                    <Checkbox value="AUDIO" label="AUDIO" />
                </Tooltip>
                <Space h={"sm"}/>
                <Tooltip label="Video File (e.g., MP4, AVI)">
                    <Checkbox value="VIDEO" label="VIDEO" />
                </Tooltip>
                <Space h={"sm"}/>
                <Tooltip label="Document Files (e.g., PDF)">
                    <Checkbox value="DOCUMENTS" label="DOCUMENTS" />
                </Tooltip>
            {/* </Group> */}
        </Checkbox.Group>
        <Space h={"sm"} /> 
        {/* <Tooltip label="Toggle case sensitivity for URLs">
            <Checkbox
                className={styles.notifyCheckbox}
                label="Ignore case on URLs"
                {...form.getInputProps('ignoreCaseUrls')}
            />
        </Tooltip>
        <Tooltip label="Choose whether to ignore robots.txt rules">
            <Checkbox
                className={styles.notifyCheckbox}
                label="Ignore robots.txt rules"
                {...form.getInputProps('ignoreRobotTxt')}
            />
        </Tooltip> */}
            <Button
                disabled={loading}
                type='submit'>
                {loading ? (
                    <>
                        Loading
                        <AutomatedAuditLoader />
                    </>
                ) : '  Update Sitemap'
                }
            </Button>
    </form>
    );
};


function ManageUniquePages({ website}: { website: ISiteListData }) {

    const { company_id, tenantId } = useAppSelector((state) => state.user.data, shallowEqual);
    // const dispatch = useAppDispatch();
    const { showAlert } = useAlert()
    const [useHashFunction, setUseHashFunction] = useState(false);
    const [pageLimit, setPageLimit] = useState<any>(undefined);

  
    async function hangleUpdate() {

        try {
            // setUseHashFunction(useHashFunction);
        
            const data = {
                frequency: website?.frequency ?? 'None',
                auditSpeed: website?.auditSpeed ?? 'normal',
                notifications: website?.notifications,
                name: website?.name,
                useHashFunction: String(useHashFunction),
                pageLimit,
                url:website.url
            };
        
            const response = await apiInstance.put(
                `reporttool/settings/${website?.id}`,
                data
            );
        
            if (response.status === 200 && response?.data?.site) {
                const message = useHashFunction
                    ? 'Successfully enabled hash function.'
                    : 'Successfully disabled hash function.';
        
                showAlert({
                    id: response?.data?.site?.company_id,
                    title: 'Site Settings Updated',
                    message,
                    variant: 'success',
                    autoClose: 3000,
                });
                return;
            }
        
            showAlert({
                id: 'error',
                title: 'Update Failed',
                message: 'Unable to update site settings. Please try again.',
                variant: 'error',
                autoClose: 3000,
            });
        } catch (error) {
            showAlert({
                id: 'error',
                title: 'Update Failed',
                message: 'An unexpected error occurred. Please try again later.',
                variant: 'error',
                autoClose: 3000,
            });
        }
        
    }
    return (
        <div style={{ paddingLeft: "20px" }}>
        {/* <Tooltip label="Toggle using URL to determine unique page">
            <div>
                <CheckboxMantin label="Use URL to determine unique page" checked={useUrl} className={styles.notifyCheckbox} onChecked={(e) => setUseUrl(e.currentTarget.checked)} />
            </div>
        </Tooltip>

        <Tooltip label="Toggle using page content to determine unique page">
            <div>
                <CheckboxMantin label="Use the page content to determine unique page" checked={useContent} className={styles.notifyCheckbox} onChecked={(e) => setUseContent(e.currentTarget.checked)} />
            </div>
        </Tooltip>

        <Tooltip label="Toggle discarding fragment identifiers when determining unique URLs">
            <div>
                <CheckboxMantin label="Discard fragment identifiers when determining unique URLs" checked={discardFragments} className={styles.notifyCheckbox} onChecked={(e) => setDiscardFragments(e.currentTarget.checked)} />
            </div>
        </Tooltip>

        <Tooltip label="Toggle discarding all URL parameters when determining unique URLs">
            <div>
                <CheckboxMantin label="Discard all URL parameters when determining unique URLs" checked={discardParameters} className={styles.notifyCheckbox} onChecked={(e) => setDiscardParameters(e.currentTarget.checked)} />
            </div>
        </Tooltip>

        <Tooltip label="URL Parameters to use when determining unique URLs:">
            <div>
                <Textarea label="URL Parameters to use when determining unique URLs:" value={parametersToUse} onChange={(e) => setParametersToUse(e.currentTarget.value)} />
            </div>
        </Tooltip>

        <Tooltip label="URL Parameters to discard when determining unique URLs:">
            <div>
                <Textarea label="URL Parameters to discard when determining unique URLs:" value={parametersToDiscard} onChange={(e) => setParametersToDiscard(e.currentTarget.value)} />
            </div>
        </Tooltip> */}

        <Tooltip label="Toggle using the built-in hash function">
            <div>
            <Checkbox 
            label="Use The Built-in Hash Function"
            className={styles.notifyCheckbox}
            checked={useHashFunction}
            onChange={(e) => setUseHashFunction(e.currentTarget.checked) } />
            </div>
        </Tooltip>

        <Tooltip label="Page Limit">
            <div>
                <NumberInput 
                label="Page Limit"
                className={styles.notifyCheckbox}
                value={pageLimit}
                onChange={(e) => setPageLimit(e) } />
            </div>
        </Tooltip>

        <Button onClick={() => { return hangleUpdate() } } className={styles['form-btn']} >
            Save Changes
        </Button>
        
        {/* <Tooltip label="Javascript to produce content hash">
            <div>
                <Textarea label="Javascript to produce content hash:" value={customHashFunction} onChange={(e) => setCustomHashFunction(e.currentTarget.value)} />
            </div>
        </Tooltip> */}
    </div>
    )
}

function ApiIntegrationPreview({ website }: { website: ISiteListData }) {
    const  [ userToken , setUserToken ] = useState("")
    async function getUserToken() {
       try { 
        const response = await apiInstance.get('reporttool/admin/generate-token-for-me')
        // console.log( response );
        setUserToken( response?.data?.token ?? "" )
       }catch{
        console.log( `error `);
       }
        
    }
    return (
        <Accordion 
        chevronPosition="left"
        variant="separated"
        radius={'lg'}
        multiple={false}
        onChange={(e) => {
            if ( !userToken &&  e == 'api_run_audit' ) {
                getUserToken()
            }
        }}
        // defaultValue={siteUUID ? [siteUUID] : undefined}
        // id="MainAccordion"
        chevron={<ChevronUp className={styles.circelBorder} />}
        >
            <Accordion.Item value={'api_run_audit'} >
                <Accordion.Control>
                    <Text weight={700} color='dark' size={"md"}>Start Website Audit</Text> 
                </Accordion.Control>
                <Accordion.Panel>
                    <ApiRunAudit siteUUID={website?.id ?? ""} token={userToken} />   
                 </Accordion.Panel>
            </Accordion.Item>

            {/* <Accordion.Item value={'api_check_audit_status'} >
                <Accordion.Control>
                    <Text weight={700} color='dark' size={"md"}>Check Website Audit Status</Text> 
                </Accordion.Control>
                <Accordion.Panel>
                    <ApiCheckAuditStatus siteUUID={website?.id ?? ""} reportId={'website'} />   
                 </Accordion.Panel>
            </Accordion.Item>

            <Accordion.Item value={'ApiStopAudit'} >
                <Accordion.Control>
                    <Text weight={700} color='dark' size={"md"}>Stop { website?.siteId} Audit Report From Running  </Text> 
                </Accordion.Control>
                <Accordion.Panel>
                    <ApiStopAudit siteUUID={website?.id ?? ""} />   
                 </Accordion.Panel>
            </Accordion.Item>

            <Accordion.Item value={'report_issues'} >
                <Accordion.Control>
                    <Text weight={700} color='dark' size={"md"}>Get { website?.siteId} Audit Report Criterias Issues  </Text> 
                </Accordion.Control>
                <Accordion.Panel>
                    <ApiGetCriteriasData siteUUID={website?.id ?? ""} />   
                 </Accordion.Panel>
            </Accordion.Item>

            <Accordion.Item value={'api_download_csv'} >
                <Accordion.Control>
                    <Text weight={700} color='dark' size={"md"}>Download { website?.siteId} Report as CSV </Text> 
                </Accordion.Control>
                <Accordion.Panel>
                    <ApiDownloadCSVFile report_id={website?.id ?? ""} name={website?.siteId ?? ""} />   
                 </Accordion.Panel>
            </Accordion.Item> */}
        </Accordion>
    )
}

export  function ApiRunAudit({siteUUID , token} : { siteUUID : string , token : string }) {

    const origin  = window.location.origin;
    // const [codeType, setCodeType] = useState<string | null>("curl")
    const apiUrl = getApiUrl(origin as envType)
    const curlCode=  `curl -X POST ${apiUrl}/api/v1/reporttool/audit/run -H "Content-Type: application/json" -H "Authorization: Bearer ${token}" -d '{"siteUUID": "${siteUUID}"}'`
    // const curlCode = `curl ${apiUrl}/api/v1/reporttool/audit/run -H "Content-Type: application/json" -H "x-api-token: "${token}"" -d '{"siteUUID": "${siteUUID}"}'`
  
    const vanillaCode = `// Vanilla JavaScript API call example
  async function startWebsiteAudit(siteUUID) {
    try {
      const response = await fetch('${apiUrl}/api/v1/reporttool/audit/run', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization' : 'Bearer ${token}'},
        body: JSON.stringify({
          siteUUID: ${siteUUID},
        }),
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error starting audit:', error);
      throw error;
    }
  }
  
  // Usage example
  document.getElementById('startAuditButton').addEventListener('click', async () => {
    try {
      const result = await startWebsiteAudit(${siteUUID});
      console.log('Audit started:', result);
    } catch (error) {
      console.error('Failed to start audit:', error);
    }
  });`
  
    return (
       
            <Box mb={15}>
              <Text size="lg" mb={10}>
                Use our API to start a website audit programmatically.
              </Text>
                <Space h={"30"}/>
                <Text size="sm" mt={15}>
                <strong>Endpoint:</strong> {apiUrl}/api/v1/reporttool/audit/run
                </Text>
                <Space h="sm" />
                <Text size="sm">
                <strong>Method:</strong> POST
                </Text>
                <Space h="sm" />
                <Text size="sm">
                <strong>Headers:</strong>
                </Text>
                <Space h="xs" />
                <Text size="sm">
                <Code>
                    {`
                    'Content-Type': 'application/json'
                    'Authorization': 'Bearer ${token}'`
                    }
                </Code>
                </Text>
                <Space h="sm" />
                <Text size="sm">
                <strong>Request Body:</strong> JSON object containing:
                </Text>
                <Space h="xs" />
                <Text size="sm">
                <Code>
                    {`{"siteUUID": ${siteUUID} }`}
                </Code>
                </Text>
                <Space h="sm" />
                <Text size="sm">
                <strong>Response:</strong> JSON object with audit execution status.
                </Text>
              {/* <Select
                value={codeType}
                onChange={setCodeType}
                data={[
                  { value: "curl", label: "Curl Example" },
                  { value: "vanilla", label: "Vanilla JavaScript" },
                ]}
                mb={20}
                mt={20}

              /> */}
              <Paper withBorder p="xs" radius="md">
                <Group position="right" mb={5}>
                  <CopyButton value={curlCode} timeout={2000}>
                    {({ copied, copy }) => (
                      <ActionIcon color={copied ? "teal" : "gray"} onClick={copy}>
                        {copied ? <Check size={16} /> : <Copy size={16} />}
                      </ActionIcon>
                    )}
                  </CopyButton>
                </Group>
  
    {/* <Flex my={"md"} direction={"column"}> */}
                    {/* <Text size="sm" mb={10}>
                        Authorization Token 
                    </Text>
                    <Code block>
                        {`{ headers : { 'Authorization' : 'Bearer ${token}'} }`}
                    </Code> */}
                {/* </Flex> */}
                <Code block>{curlCode}</Code>
              </Paper>
                    
        </Box>
     
    )
}

export  function ApiCheckAuditStatus({siteUUID , reportId } : { siteUUID : string , reportId : string }) {
    const [codeType, setCodeType] = useState<string | null>("curl")
  
    const curlCode = `curl -X POST https://vially.io/api/v1/reporttool/audit/status/{siteUUID}/{reportId} \
  -H "Authorization: Bearer {{token}}"`
  
    const vanillaCode = `// Vanilla JavaScript API call example
  async function checkStatus(siteUUID) {
    try {
      const response = await fetch('https://vially.io/api/v1/reporttool/audit/status/{siteUUID}/{reportId}', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization' : 'Bearer {{token}}'
        }
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error starting audit:', error);
      throw error;
    }
  }
  
  // Usage example
  document.getElementById('startAuditButton').addEventListener('click', async () => {
    try {
      const result = await checkStatus(${siteUUID} , ${reportId});
      console.log('Audit status:');
      console.log(result)
    } catch (error) {
      console.error('Failed to start audit:', error);
    }
  });`
  
    return (
       
            <Box mb={15}>
              <Text size="sm" mb={10}>
                Use our API to check a status of a  website that its been audited programmatically. Choose your preferred implementation:
              </Text>
  
              <Select
                value={codeType}
                onChange={setCodeType}
                data={[
                  { value: "curl", label: "Curl Example" },
                  { value: "vanilla", label: "Vanilla JavaScript" },
                ]}
                mb={15}
              />
  
              <Paper withBorder p="xs" radius="md">
                <Group position="right" mb={5}>
                  <CopyButton value={codeType === "curl" ? curlCode : vanillaCode} timeout={2000}>
                    {({ copied, copy }) => (
                      <ActionIcon color={copied ? "teal" : "gray"} onClick={copy}>
                        {copied ? <Check size={16} /> : <Copy size={16} />}
                      </ActionIcon>
                    )}
                  </CopyButton>
                </Group>
  
    <Flex my={"md"} direction={"column"}>
                    <Text size="sm" mb={10}>
                        Make Sure you Include the Authorization Token In headers
                    </Text>
                    <Code block>
                        {`{ headers : { 'Authorization' : 'Bearer {{token}}'} }`}
                    </Code>
                </Flex>
                <Code block>{codeType === "curl" ? curlCode : vanillaCode}</Code>
              </Paper>
                    
            <Space h={"sm"}/>
            <Text size="sm" mt={15}>
                <strong>Endpoint:</strong>https://vially.io/api/v1/reporttool/audit/status/{'siteUUID'}/{'reportId'}
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Method:</strong> GET
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Content-Type:</strong> application/json
            </Text>
        </Box>
     
    )
}


export  function ApiDownloadCSVFile({report_id , name } : { report_id : string , name : string }) {
    const [codeType, setCodeType] = useState<string | null>("curl")
  
    const curlCode = `curl -X POST https://vially.io/api/v1/reporttool/organisationlevel/sites/issues/csv/download \
  -H "Content-Type: application/json" \
  -H "Authorization: Bearer {{token}}" \
  -d '{"report_id": "your-report-id"}' \
  --output report-your-report-id.csv`
  
    const vanillaCode = `// Vanilla JavaScript API call example
async function handleDownloadCsvFile(report_id, name) {
  try {
    const response = await fetch('https://vially.io/api/v1/reporttool/organisationlevel/sites/issues/csv/download', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : 'Bearer {{token}}'
      },
      body: JSON.stringify({ report_id }),
    });

    if (!response.ok) {
      return { error: new Error('Download failed') };
    }

    const blob = await response.blob();
    
    const contentDisposition = response.headers.get('content-disposition');
    const downloadDate = new Date();
    const formattedDate = downloadDate.toISOString().slice(0, 10);
    let filename = name || 'report' + '-' + report_id + '.csv';

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    console.log('File downloaded successfully');

    return { error: null };
  } catch (error) {
    console.log(error);
    return {
      error: new Error('Download failed')
    };
  }
}

// Add event listener to your download button
document.addEventListener('DOMContentLoaded', () => {
  const downloadButton = document.getElementById('download-button');
  
  downloadButton.addEventListener('click', async () => {
    
    const { error } = await handleDownloadCsvFile(${report_id}, 'website');
    
    if (!error) {
      console.log('Enable to download');
    }
  });
});
    `
    return (
       
            <Box mb={15}>
              <Text size="sm" mb={10}>
                Use our API to Download Website Report programmatically. Choose your preferred implementation:
              </Text>
              <Select
                value={codeType}
                onChange={setCodeType}
                data={[
                  { value: "curl", label: "Curl Example" },
                  { value: "vanilla", label: "Vanilla JavaScript" },
                ]}
                mb={15}
              />
  
              <Paper withBorder p="xs" radius="md">
                <Group position="right" mb={5}>
                  <CopyButton value={codeType === "curl" ? curlCode : vanillaCode} timeout={2000}>
                    {({ copied, copy }) => (
                      <ActionIcon color={copied ? "teal" : "gray"} onClick={copy}>
                        {copied ? <Check size={16} /> : <Copy size={16} />}
                      </ActionIcon>
                    )}
                  </CopyButton>
                </Group>
  
                <Flex my={"md"} direction={"column"}>
                    <Text size="sm" mb={10}>
                        Make Sure you Include the Authorization Token In headers
                    </Text>
                    <Code block>
                        {`{ headers : { 'Authorization' : 'Bearer {{token}}'} }`}
                    </Code>
                </Flex>
                <Code block>{codeType === "curl" ? curlCode : vanillaCode}</Code>
              </Paper>
                    
            <Space h={"sm"}/>
            <Text size="sm" mt={15}>
                <strong>Endpoint:</strong>https://vially.io/api/v1/reporttool/organisationlevel/sites/issues/csv/download
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Method:</strong> POST
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Content-Type:</strong> application/json
            </Text>
        </Box>
     
    )
}


export  function ApiStopAudit({siteUUID } : {  siteUUID : string }) {
    const [codeType, setCodeType] = useState<string | null>("curl")
  
    const curlCode = `curl -X POST https://vially.io/api/v1/reporttool/audit/stop/{siteUUID} \
  -H "Authorization: Bearer {{token}}"`
  
    const vanillaCode = `// Vanilla JavaScript API call example
  async function StopAudit(siteUUID) {
    try {
      const response = await fetch('https://vially.io/api/v1/reporttool/audit/stop/{siteUUID}', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
           'Authorization' : 'Bearer {{token}}'
        }
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error starting audit:', error);
      throw error;
    }
  }
  
  // Usage example
  document.getElementById('stopAuditButton').addEventListener('click', async () => {
    try {
      const result = await StopAudit(${siteUUID});
      console.log('Stop Audit:');
      console.log(result)
    } catch (error) {
      console.error('Failed to start audit:', error);
    }
  });`
  
    return (
       
            <Box mb={15}>
              <Text size="sm" mb={10}>
                Use our API to Stop Website Report Audit programmatically. Choose your preferred implementation:
              </Text>
              <Select
                value={codeType}
                onChange={setCodeType}
                data={[
                  { value: "curl", label: "Curl Example" },
                  { value: "vanilla", label: "Vanilla JavaScript" },
                ]}
                mb={15}
              />
  
              <Paper withBorder p="xs" radius="md">
                <Group position="right" mb={5}>
                  <CopyButton value={codeType === "curl" ? curlCode : vanillaCode} timeout={2000}>
                    {({ copied, copy }) => (
                      <ActionIcon color={copied ? "teal" : "gray"} onClick={copy}>
                        {copied ? <Check size={16} /> : <Copy size={16} />}
                      </ActionIcon>
                    )}
                  </CopyButton>
                </Group>
                  <Flex my={"md"} direction={"column"}>
                    <Text size="sm" mb={10}>
                        Make Sure you Include the Authorization Token In headers
                    </Text>
                    <Code block>
                        {`{ headers : { 'Authorization' : 'Bearer {{token}}'} }`}
                    </Code>
                </Flex>
                <Code block>{codeType === "curl" ? curlCode : vanillaCode}</Code>
              </Paper>
                    
            <Space h={"sm"}/>
            <Text size="sm" mt={15}>
                <strong>Endpoint:</strong>https://vially.io/api/v1/reporttool/audit/stop/{'siteUUID'}
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Method:</strong> GET
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Content-Type:</strong> application/json
            </Text>
        </Box>
     
    )
}


export  function ApiGetCriteriasData({siteUUID } : {  siteUUID : string }) {
    const [codeType, setCodeType] = useState<string | null>("curl")
  
    const curlCode = `curl -X POST https://vially.io/api/v1/reporttool/usermanagement/issues/getmapbasedoncriterias \
                        -H "Content-Type: application/json" \
                        -H "Authorization: Bearer {{token}}" \
                        -d '{"siteUUID": "your-site-uuid"}'`
  
    const vanillaCode = `// Vanilla JavaScript API call example
  async function getIssuesList(siteUUID) {
    try {
      const response = await fetch('https://vially.io/api/v1/reporttool/usermanagement/issues/getmapbasedoncriterias', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : 'Bearer {{token}}'
            }
        });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error starting audit:', error);
      throw error;
    }
  }
  
  // Usage example
  document.getElementById('stopAuditButton').addEventListener('click', async () => {
    try {
      const result = await getIssuesList(${siteUUID});
      console.log('Issues List Audit:');
      console.log(result)
    } catch (error) {
      console.error('Failed to start audit:', error);
    }
  });`
  
    return (
       
            <Box mb={15}>
              <Text size="sm" mb={10}>
                Use our API to get Website Report Audit Issues programmatically. Choose your preferred implementation:
              </Text>
              <Select
                value={codeType}
                onChange={setCodeType}
                data={[
                  { value: "curl", label: "Curl Example" },
                  { value: "vanilla", label: "Vanilla JavaScript" },
                ]}
                mb={15}
              />
  
              <Paper withBorder p="xs" radius="md">
                <Group position="right" mb={5}>
                  <CopyButton value={codeType === "curl" ? curlCode : vanillaCode} timeout={2000}>
                    {({ copied, copy }) => (
                      <ActionIcon color={copied ? "teal" : "gray"} onClick={copy}>
                        {copied ? <Check size={16} /> : <Copy size={16} />}
                      </ActionIcon>
                    )}
                  </CopyButton>
                </Group>
  
    <Flex my={"md"} direction={"column"}>
                    <Text size="sm" mb={10}>
                        Make Sure you Include the Authorization Token In headers
                    </Text>
                    <Code block>
                        {`{ headers : { 'Authorization' : 'Bearer {{token}}'} }`}
                    </Code>
                </Flex>
                <Code block>{codeType === "curl" ? curlCode : vanillaCode}</Code>
              </Paper>
                    
            <Space h={"sm"}/>
            <Text size="sm" mt={15}>
                <strong>Endpoint:</strong>https://vially.io/api/v1/reporttool/usermanagement/issues/getmapbasedoncriterias
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Method:</strong> POST
            </Text>
            <Space h={"sm"} />
            <Text size="sm">
                <strong>Content-Type:</strong> application/json
            </Text>
        </Box>
     
    )
}

type envType = 'https://dev.vially.io' | 'https://test.vially.io' | 'https://staging.vially.io' | 'https://vially.io'

const getApiUrl =(env:envType) => {
    const keys = {
      'http://localhost:3000': "https://dev.vially.io",
      'https://dev.vially.io': "https://dev.vially.io",
      'https://test.vially.io': "https://test.vially.io",
      'https://staging.vially.io': "https://staging.vially.io",
      'https://vially.io': "https://vially.io"
    };
  
    return keys[env];
  }